function fpT(key, fallback) {
  if (window.fpI18n && window.fpI18n[key]) return window.fpI18n[key];
  return fallback;
}

function normalizeConfiguratorHeader(name) {
  if (!name) return name;

  const trimmed = name.trim();
  const aliases = {
    'Leather Color & Laces': 'Color Leather & Laces',
    'Leather Color and Laces': 'Color Leather & Laces',
    'Color Leather and Laces': 'Color Leather & Laces',
  };

  return aliases[trimmed] || trimmed;
}

function normalizeConfiguratorValue(value) {
  if (!value) return value;

  return value.trim();
}

function applyConfiguratorSelections() {
  document.querySelectorAll('.cst-cart-item').forEach(function(cartItem) {
    cartItem.querySelectorAll('.product-option').forEach(function(productOption) {
      const propHeader = productOption.querySelector('.prop-header');
      const propValue = productOption.querySelector('.prop-value');

      if (!propHeader || !propValue) return;

      const headerValue = normalizeConfiguratorHeader(propHeader.getAttribute('data-header'));
      const value = normalizeConfiguratorValue(propValue.getAttribute('prop-value'));

      cartItem.querySelectorAll('.pro-option-props-grid-item').forEach(function(gridItem) {
        const gridHeader = gridItem.querySelector('.props-item-header');
        if (!gridHeader) return;

        if (normalizeConfiguratorHeader(gridHeader.getAttribute('data-header')) === headerValue) {
          gridItem.querySelectorAll('.props-item-option-single').forEach(function(optionSingle) {
            if (normalizeConfiguratorValue(optionSingle.getAttribute('data-value')) === value) {
              optionSingle.classList.add('active');
            }
          });
        }
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', applyConfiguratorSelections);

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
    applyConfiguratorSelections();
  });
}

  // //Ak custom code
  // if(document.body.classList.contains('template-cart')){
  
  //   //on load and on scan item click 
  //   const submitButton = document.querySelector('.cart__footer .cart__ctas'); // Adjust if needed
  
  //   function updateButtonState() {
  //     const cartItems = document.querySelectorAll('.cart-item.cst-cart-item');
  //     const totalItems = cartItems.length;
  //     const activeCount = [...cartItems].filter(item =>
  //       item.querySelector('.cart-accordian.size_accordion.active')
  //     ).length;
  
  //     if (activeCount === totalItems && totalItems > 0) {
  //       submitButton.removeAttribute('disabled');
  //     } else {
  //       submitButton.setAttribute('disabled', 'disabled');
  //     }
  //   }
  
  
  //   function updateCartItemProperties(lineIndex, newProps = {}) {
  //     fetch('/cart.js')
  //       .then(res => res.json())
  //       .then(cart => {
  //         const item = cart.items[lineIndex];
  //         if (!item) return;
    
  //         const existingProps = item.properties || {};
    
  //         // Create a copy and update relevant fields
  //         const updatedProps = { ...existingProps };
    
  //         // Remove old standard size props
  //         delete updatedProps.form_standard_size;
  //         delete updatedProps.form_standard_size_left;
  //         delete updatedProps.form_standard_size_right;
    
  //         // Add new ones
  //         Object.assign(updatedProps, newProps);
    
  //         fetch('/cart/change.js', {
  //           method: 'POST',
  //           headers: {
  //             'Content-Type': 'application/json'
  //           },
  //           body: JSON.stringify({
  //             line: lineIndex + 1, // Shopify's line index starts from 1
  //             quantity: item.quantity,
  //             properties: updatedProps
  //           })
  //         })
  //         .then(res => res.json())
  //         .then(data => {
  //           console.log('Cart updated with merged properties:', data);
  //         })
  //         .catch(err => {
  //           console.error('Error updating cart item:', err);
  //         });
  //       });
  //   }

  
  //   document.querySelectorAll('.cart-item.cst-cart-item').forEach((cartItem, index) => {
  //     const wraps = cartItem.querySelectorAll('.my-scans-wrap');
  
  //     wraps.forEach(wrap => {
  //      wrap.addEventListener('click', () => {
  //       wraps.forEach(w => w.querySelector('.my-scans-item').classList.remove('active'));
  //       const activeItem = wrap.querySelector('.my-scans-item');
  //       if (activeItem) activeItem.classList.add('active');

  //       // Add `active` class to the parent cart item accordion
  //       const cartAccordion = wrap.closest('.cart-accordian.accordion');
  //       if (cartAccordion) {
  //         cartAccordion.classList.add('active');
  //       }
      
  //       const leftSize = wrap.getAttribute('data-left-size');
  //       const rightSize = wrap.getAttribute('data-right-size');
      
  //       let newProps = {};
  //       if (leftSize === rightSize) {
  //         newProps["form_standard_size"] = leftSize;
  //       } else {
  //         newProps["form_standard_size_left"] = leftSize;
  //         newProps["form_standard_size_right"] = rightSize;
  //       }
      
  //       updateCartItemProperties(index, newProps);
  //       updateButtonState();
  //     });

        
  //     });
  //   });
  
  //   updateButtonState(); // Check on load
  //   //End on load and on scan item click 
    
  //   // const installBtn = document.querySelector(".empty-scan-block .button[data-cust-id]");
  //   // if (!installBtn) return;

  //   // installBtn.addEventListener("click", function (e) {
  //   //   e.preventDefault();

  //   //   const custId = installBtn.getAttribute("data-cust-id");
  //   //   const custEmail = installBtn.getAttribute("data-cust-email");
  //   //   const custName = installBtn.getAttribute("data-cust-name");
  //   //   if (!custId) return;
  //   //   if (!custEmail) return;
  //   //   if (!custName) return;

  //   //   const qrContainer = document.getElementById("qrcode");
  //   //   qrContainer.innerHTML = ""; // Clear existing QR if needed

  //   //   async function generateUniqueCode(id, email) {
  //   //     const randomNum = Math.floor(Math.random() * 1_000_000);
  //   //     const data = `${id}|${email}|${randomNum}`;
      
  //   //     const encoder = new TextEncoder();
  //   //     const dataBuffer = encoder.encode(data);
      
  //   //     const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
      
  //   //     // Convert buffer to hex string
  //   //     const hashArray = Array.from(new Uint8Array(hashBuffer));
  //   //     const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
      
  //   //     return hashHex;  // This is the unique code that cannot be decoded back
  //   //   }
      
  //   //   // Usage example:
  //   //   generateUniqueCode(custId, custEmail).then(code => {
  //   //     // console.log('Unique non-decodable code:', code);
  //   //     const urlToEncode = `https://dddemo.net/php/2025/vijay/footprint/Qr.php?id=${custId}&name=${custName}&email=${custEmail}&qr_id=${code}`; // Adjust this as needed
  //   //     qrContainer.innerHTML = "<img src='"+urlToEncode+"'/>";

  //   //     const empty_scan_block = document.querySelector('.empty-scan-block');
  //   //     if(empty_scan_block){
  //   //       empty_scan_block.classList.add('hidden');
  //   //     }


  //   //     //call API
  //   //     pollUserDetail(code);
  //   //     //End Calll API
      
  //   //   });
      
  //   // });

  //   const installButtons = document.querySelectorAll(".empty-scan-block .button[data-cust-id]");
  //   // if (!installButtons.length) return;
    
  //   installButtons.forEach((installBtn) => {
  //     installBtn.addEventListener("click", function (e) {
  //       e.preventDefault();
    
  //       const custId = installBtn.getAttribute("data-cust-id");
  //       const custEmail = installBtn.getAttribute("data-cust-email");
  //       const custName = installBtn.getAttribute("data-cust-name");
  //       if (!custId || !custEmail || !custName) return;
    
  //       const qrContainer = this.closest('.tab-content').querySelector('.qrcode');
  //       //document.getElementById("qrcode");
  //       if (qrContainer) qrContainer.innerHTML = "";
    
  //       async function generateUniqueCode(id, email) {
  //         const randomNum = Math.floor(Math.random() * 1_000_000);
  //         const data = `${id}|${email}|${randomNum}`;
    
  //         const encoder = new TextEncoder();
  //         const dataBuffer = encoder.encode(data);
    
  //         const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
  //         const hashArray = Array.from(new Uint8Array(hashBuffer));
  //         const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  //         return hashHex;
  //       }
    
  //       generateUniqueCode(custId, custEmail).then(code => {
  //         const urlToEncode = `https://dddemo.net/php/2025/vijay/footprint/Qr.php?id=${custId}&name=${custName}&email=${custEmail}&qr_id=${code}`;
  //         if (qrContainer) {
  //           qrContainer.innerHTML = `<img src="${urlToEncode}" />`;
  //         }
    
  //         const emptyScanBlock = installBtn.closest('.empty-scan-block');
  //         if (emptyScanBlock) {
  //           emptyScanBlock.classList.add('hidden');
  //         }
    
  //         pollUserDetail(code); // This function will poll the server until status is 1
  //       });
  //     });
  //   });

  //   const scan_plus_buttons = document.querySelectorAll(".my-scans .more-scan-btn[data-cust-id]");
  //   scan_plus_buttons.forEach((scan_btn) => {
  //     scan_btn.addEventListener("click", function (e) {
  //       e.preventDefault();
    
  //       const custId = scan_btn.getAttribute("data-cust-id");
  //       const custEmail = scan_btn.getAttribute("data-cust-email");
  //       const custName = scan_btn.getAttribute("data-cust-name");
  //       if (!custId || !custEmail || !custName) return;
    
  //       const qrContainer = this.closest('.tab-content').querySelector('.qrcode');
  //       //document.getElementById("qrcode");
  //       if (qrContainer) qrContainer.innerHTML = "";
    
  //       async function generateUniqueCode(id, email) {
  //         const randomNum = Math.floor(Math.random() * 1_000_000);
  //         const data = `${id}|${email}|${randomNum}`;
    
  //         const encoder = new TextEncoder();
  //         const dataBuffer = encoder.encode(data);
    
  //         const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
  //         const hashArray = Array.from(new Uint8Array(hashBuffer));
  //         const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  //         return hashHex;
  //       }
    
  //       generateUniqueCode(custId, custEmail).then(code => {
  //         const urlToEncode = `https://dddemo.net/php/2025/vijay/footprint/Qr.php?id=${custId}&name=${custName}&email=${custEmail}&qr_id=${code}`;
  //         if (qrContainer) {
  //           qrContainer.innerHTML = `<img src="${urlToEncode}" />`;
  //         }
    
  //         // const emptyScanBlock = installBtn.closest('.empty-scan-block');
  //         // if (emptyScanBlock) {
  //         //   emptyScanBlock.classList.add('hidden');
  //         // }
    
  //         pollUserDetail(code); // This function will poll the server until status is 1
  //       });
  //     });
  //   });


  //   //calling api
  //   function pollUserDetail(code, interval = 3000, maxAttempts = 1) {
  //     let attempts = 0;
    
  //     const poll = () => {
  //       fetch('https://dddemo.net/php/2025/vijay/footprint/get_user_detail.php', {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json'
  //         },
  //         body: JSON.stringify({ code })
  //       })
  //       .then(response => response.json())
  //       .then(data => {
  //         // console.log('Polling response:', data);
  //         if (data.status == 1) {
  //           console.log("Data ready:", data);
  //           location.reload();
  //           // You can do something here like update the UI, stop loading spinner, etc.
  //         } else {
  //           attempts++;
  //           if (attempts < maxAttempts) {
  //             setTimeout(poll, interval); // Try again after `interval` ms
  //           } else {
  //             console.warn("Max attempts reached without getting status 1");
  //           }
  //         }


  //         //refresh data
  //         fetch(window.location.pathname)  // Replace section_id with your section
  //         .then(response => response.text())
  //         .then(html => {
  //           const parser = new DOMParser();
  //           const doc = parser.parseFromString(html, 'text/html');
      
  //           const newContent = doc.querySelector('.cart-accordian.size_accordion');
  //           const contentWrapper = document.querySelector('.cart-accordian.size_accordion');
      
  //           if (newContent && contentWrapper) {
  //             contentWrapper.innerHTML = newContent.innerHTML;
      
  //             // ✅ Re-initialize any scripts or event bindings here
  //             cart_cstm_size_events();
  //           }
  //         })
  //         .catch(error => {
  //           console.error('AJAX load failed:', error);
  //         });
          
  //       })
  //       .catch(error => {
  //         console.error("Error during polling:", error);
  //         // You may want to retry even on error, or stop
  //       });
  //     };
    
  //     poll();
  //   }

    
  // }
  // //Ak custom code
  
// Back to top
var amountScrolled = 200;
var amountScrolledNav = 25;

$(window).scroll(function() {
  if ( $(window).scrollTop() > amountScrolled ) {
    $('button.back-to-top').addClass('show');
  } else {
    $('button.back-to-top').removeClass('show');
  }
});

$('.add-address > button').click(function() {
  $('html, body').animate({
    scrollTop: 0
  }, 800);
  return false;
});

$('button.back-to-top').click(function() {
  $('html, body').animate({
    scrollTop: 0
  }, 800);
  return false;
});

$(function() {
  $('.scroll-next-btn a').on('click', function(e) {
    e.preventDefault();

    var headerHeight = $('sticky-header').outerHeight() || 0;

    // Zum naechsten Abschnitt statt zu einer festen Sprungmarke.
    //
    // Der Pfeil im Hero zeigte auf #image-with-text. Diese Marke sitzt
    // in cstm-image-with-text, inzwischen dem fuenften Abschnitt: seit
    // der Vorstellungstext und die Auszeichnung davor stehen, sprang
    // der Pfeil ueber beide hinweg und landete mitten auf der Seite.
    //
    // Der naechste Abschnitt ist immer der richtige, egal welche
    // Abschnitte dazukommen, wegfallen oder die Plaetze tauschen. Die
    // Sprungmarke aus dem href bleibt als Rueckfall.
    var $next = $(this).closest('.shopify-section').next('.shopify-section');
    var $ziel = $next.length ? $next : $($(this).attr('href'));
    if (!$ziel.length) return;

    $('html, body').animate({
      scrollTop: $ziel.offset().top - headerHeight
    }, 500, 'linear');
  });
});

$(document).ready(function(){
  $('.testimonials-main .review-grid').slick({
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '.visual-prev',
    nextArrow: '.visual-next',
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });


  $('.design-material-item.onenumber .main_material').slick({
    infinite: false,
    speed: 300,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    	arrows: true,
    responsive: [
      {
        breakpoint: 1449,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 2
        }
      },
     {
        breakpoint: 749,
        settings: {
           variableWidth: true,
          	arrows: false
        }
      }
    ]
  });

  $('.design-material-item.othercolumn .main_material').slick({
    infinite: false,
    speed: 300,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 6
        }
      },
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 4
        }
      },
         {
        breakpoint: 749,
        settings: {
           slidesToShow: 4,
          	arrows: false
        }
      }
    ]
  });


  if ($(window).width() < 1280) {
    $('body:not(.help-page):not(.template-cart) .collapsible-content .grid').slick({
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });
  } 
});

$(document).ready(function() {
    // function updateActiveFromUrl() {
    //     var urlParams = new URLSearchParams(window.location.search);
    //   console.log("urlParams >>> ",urlParams);
    //     var currentPref = urlParams.keys().next().value; // Get first query parameter key
    //     console.log("currentPref >>> ",currentPref);
    //     if (currentPref) {
    //         var activeNav = $('.account__navigation-wrap [data-link-pref="' + currentPref + '"]');
    //       console.log("activeNav >> ",activeNav);
    //         var activeContent = $('.customer-account [data-pref="' + currentPref + '"]');

    //         if (activeNav.length > 0 && activeContent.length > 0) {
    //             $('.account__navigation-wrap [data-link-pref]').removeClass('active');
    //             $('.customer-account [data-pref]').removeClass('active');

    //             activeNav.addClass('active');
    //             activeContent.addClass('active');
    //         }
    //     } else {
    //         $('.account__navigation-wrap [data-link-pref]').first().addClass('active');
    //         $('.customer-account [data-pref]').first().addClass('active');
    //     }
    // }
    function updateActiveFromUrl() {
      var urlParams = new URLSearchParams(window.location.search);
      var currentPref = urlParams.keys().next().value; // Get first query parameter key
  
      // If no query param is found, check the pathname
      if (!currentPref) {
          var pathSegments = window.location.pathname.split('/').filter(Boolean); // Split and remove empty segments
          if (pathSegments.includes("orders")) {
              currentPref = "order-history"; // Map orders page to order-history tab
          } else if (pathSegments.includes("addresses")) {
              currentPref = "address-book"; // Map addresses page to address-book tab
          }
      }
  
      console.log("Determined currentPref >>> ", currentPref);
  
      if (currentPref) {
          var activeNav = $('.account__navigation-wrap [data-link-pref="' + currentPref + '"]');
          var activeContent = $('.customer-account [data-pref="' + currentPref + '"]');
  
          if (activeNav.length > 0 && activeContent.length > 0) {
              $('.account__navigation-wrap [data-link-pref]').removeClass('active');
              $('.customer-account [data-pref]').removeClass('active');
  
              activeNav.addClass('active');
              activeContent.addClass('active');
          }
      } else {
          $('.account__navigation-wrap [data-link-pref]').first().addClass('active');
          $('.customer-account [data-pref]').first().addClass('active');
      }
    }

    updateActiveFromUrl(); // Initial call

    // Click event to update active state
    $('.account__navigation-wrap [data-link-pref]').click(function(e) {
        e.preventDefault();

        $('[data-link-pref]').removeClass('active');
        $('[data-pref]').removeClass('active');

        $(this).addClass('active');

        var currentPref = $(this).attr('data-link-pref');
        var accountPref = $('.customer-account').find('[data-pref="' + currentPref + '"]');

        if (accountPref.length > 0) {
            accountPref.addClass('active');
            var newUrl = window.location.pathname + '?' + currentPref; // Update URL without reload
            window.history.pushState({ path: newUrl }, '', newUrl);
        } else {
            window.location.href = $(this).attr('href');
        }
    });

    // Handle browser back/forward navigation
    window.onpopstate = function() {
        updateActiveFromUrl();
    };
});


    $(function() {
      var Accordion = function(el, multiple) {
        this.el = el || {};
        this.multiple = multiple || false;
  
        // Variables privadas
        var links = this.el.find('.js-acc-single-trigger');
        // Evento
        links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
      }
    if ($(window).width() < 750){
      Accordion.prototype.dropdown = function(e) {
        var $el = e.data.el;
          $this = $(this),
          $next = $this.next();
  
        $next.slideToggle();
        $this.parent().toggleClass('open');
  
        if (!e.data.multiple) {
          $el.find('.accordion-single-content').not($next).slideUp().parent().removeClass('open');
        };
      }
    }
      var accordion = new Accordion($('#accordion'), false);
    });

    $(".header__icon--account-wrap").hover(
        function() {
            $(this).addClass('active');
        }, function() {
            if(!$( this).hasClass('clicked') ){
                $( this ).removeClass('active');
            }
        }
    );

    $(".header__icon--account-wrap").click(function(){
        $(this).toggleClass('clicked');
    });

  // our-shoemakers page hide show content js start
  document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('.read-more-btn').forEach(button => {
          button.addEventListener('click', (e) => {
              e.preventDefault();
              const section = button.closest('.about-image-text-grid');
  
              // Slide toggle the additional content and the bottom item
              $(section.querySelector('.about-text-more p')).slideToggle();
              $(section.querySelector('.about-image-text-main .about-image-text-item.item-bottom')).slideToggle();
  
              // Toggle the buttons visibility
              button.style.display = 'none';
              section.querySelector('.read-less-btn').style.display = 'block';
          });
      });
  
      document.querySelectorAll('.read-less-btn').forEach(button => {
          button.addEventListener('click', (e) => {
              e.preventDefault();
              const section = button.closest('.about-image-text-grid');
  
              // Slide toggle the additional content and the bottom item
              $(section.querySelector('.about-text-more p')).slideToggle();
              $(section.querySelector('.about-image-text-main .about-image-text-item.item-bottom')).slideToggle();
  
              // Toggle the buttons visibility
              button.style.display = 'none';
              section.querySelector('.read-more-btn').style.display = 'block';
          });
      });
  });

  // our-shoemakers page hide show content js end


//Ak custom code
$(document).ready(function(){
  if($('body').hasClass('template-order')){
      var requestData = {};

    //on line item action click
    $('.order-main .order-summary .summary-item-wrap .change_request').on('click',function(){
      const line_id = this.getAttribute('data-line-id');
      $('.order-main .order-actions-wrap').show();
      $('html, body').animate({
        scrollTop: $('.order-main .order-actions-wrap').offset().top
      }, 600); // 600ms is the scroll duration

      sessionStorage.setItem('change_request_line_item_id', line_id);
      
    });

    $('.order-main .order-summary-wss .change_request').on('click',function(){
      const line_id = this.getAttribute('data-line-id');
      $('.order-main .order-actions-wrap').show();
      $('html, body').animate({
        scrollTop: $('.order-main .order-actions-wrap').offset().top
      }, 600); // 600ms is the scroll duration

      sessionStorage.setItem('change_request_line_item_id', line_id);
      
    });
    
    $('.order-main .order-actions-main .change_request,.order-main .quick-action-block .order-actions-mobile .change_request').on('click',function(){
      $('.order-main .order-actions-wrap').show();
    });
    $('.order-main .order-actions-wrap .order-action-select .order-action-submit button').on('click',function(){
      var get_issue_val = $(this).parents('.order-action-select').find('select').val();
      console.log(get_issue_val);

      $('.order-main .order-actions-wrap .order-action-details').removeClass('hidden');
      $('.order-main .order-actions-wrap .order-action-details').show();
      $('.order-main .order-actions-wrap .order-action-select').addClass('hidden');
      $('.order-main .order-summary-main').addClass('hidden');
      $('.order-main .order-actions-main').addClass('hidden');
      $('.order-main .order-actions-wrap .order-action-details .order-request-details').addClass('hidden');
      $('.order-main .order-actions-wrap .order-action-details .order-request-details[data-select="'+get_issue_val+'"]').removeClass('hidden');
      $('.order-main .order-actions-wrap .order-action-details .order-request-details[data-select="'+get_issue_val+'"] .request-details-main').show();
      $('.order-main .order-actions-wrap .order-action-details .order-request-details[data-select="'+get_issue_val+'"] .order-request-sub').hide();
      
    });


    //form stop
    $('.order-main .order-actions-wrap .order-action-details .request-details-main .order-request-summary .details form').on('submit', function(event) {
        event.preventDefault(); // Prevents form submission
        console.log('Form submission stopped!');
    });
    
    $('.order-main .order-actions-wrap .order-action-details .request-details-main .order-request-summary button.button').on('click',function(){
      console.log('click next')
      if($(this).parents('.order-request-details').find('.order-request-sub').length > 0){
        $(this).parents('.order-request-details').find('.order-request-sub').show();
        $(this).parents('.request-details-main').hide();

        var orderRequestDetails = $(this).parents('.order-request-details');
        // Scroll to the closest `.order-request-details`
        // orderRequestDetails[0].scrollIntoView({ behavior: 'smooth' });
        $('html, body').animate({
            scrollTop: orderRequestDetails.offset().top - 100 // Adjust '20' for the desired space
        }, 10); // Smooth scroll with a duration of 500ms
      }else{
        
        var select_issue_val = $(this).parents('.order-actions-wrap').find('.order-action-select select').val();

        if(select_issue_val.includes('other')){
          console.log('get in')
          var order_id = $('.order-main').attr('data-order-id');
          var item_ids = $('.order-main').attr('data-line-item-id').split(',');
          const item_id = sessionStorage.getItem('change_request_line_item_id')
          requestData = {
              "order_id": order_id,
              "line_item_id": item_id,
              "issue_type":"other"
          };

          // requestData = {
          //     "order_id": order_id,
          //     "line_item_id": {},
          //     "issue_type":"other"
          // };
         
          // Assign line item IDs from order
        
          // item_ids.forEach((id, index) => {
          //     requestData.line_item_id[`line_id${index + 1}`] = id;
          // });

          // Default values for issues
          requestData.fit_problem = {
              "issue_description": null,
              "type": null,
              "image": null
          };
          requestData.quality_problem = {
              "issue_description": null,
              "problem": {},
              "image": null
          };
          requestData.other_issue = {
              "issue_description": null,
              "key1": {}
          };
          
          var issue_desc = $(this).parents('.order-request-summary').find('.details .details-input textarea').val();
          if(issue_desc){
            requestData.other_issue.issue_description = issue_desc;
            console.log('data',requestData);
  
            $.ajax({
                url: "https://app.footprint-pioneers.com/shopify/order/cancel_line",
                type: "POST",
                contentType: "application/json",
                data: JSON.stringify(requestData),
                success: function (response) {
                    console.log("Response from API:", response);
                },
                error: function (xhr, status, error) {
                    console.error("Error sending data:", error);
                }
            });
            $(".order-action-details").css("display","none");
            $(".order-actions-result").removeClass('hidden');
            $(".order-actions-result").css("display", "block");
          }else{
            alert(fpT('writeIssue', 'Please write your issue'));
          }
          
        }
        
      }
     
    });
  
     $('.order-main .order-actions-wrap .order-action-details .order-request-sub .sub-request-summary .cta-button button.button').on('click',function(){
       var order_id = $('.order-main').attr('data-order-id');
       var item_ids = $('.order-main').attr('data-line-item-id').split(',');
       
       var select_issue_val = $(this).parents('.order-actions-wrap').find('.order-action-select select').val();

        const item_id = sessionStorage.getItem('change_request_line_item_id')
        requestData = {
            "order_id": order_id,
            "line_item_id": item_id,
            "issue_type":"other"
        };
       
        // requestData = {
        //     "order_id": order_id,
        //     "line_item_id": {},
        //     "issue_type":null
        // };
       
        // // Assign line item IDs from order
        // item_ids.forEach((id, index) => {
        //     requestData.line_item_id[`line_id${index + 1}`] = id;
        // });

        
        // Default values for issues
      //   requestData.fit_problem = {
      //       "issue_description": null,
      //       "type": null,
      //       "image": null
      //   };
      //   requestData.quality_problem = {
      //       "issue_description": null,
      //       "problem": {},
      //       "image": null
      //   };
      //   requestData.other_issue = {
      //       "issue_description": null,
      //       "key1": {}
      //   };
       
      //   var isValid = false;

      //  if(select_issue_val.includes('fit')){
       
      //    // console.log('hiii get fit')
      //    var issue_desc = $(this).parents('.sub-request-summary').find('.sub-request-input .input-grid-item-wrap textarea').val() || null;
      //    var issue_type = $(this).parents('.sub-request-summary').find('.sub-request-image-input .input-selection input[type="radio"]:checked').next('.label-input').text() || null ;
      //    var issue_img = $(this).parents('.sub-request-summary').find('.sub-request-image-input .request-image-wrap img').attr('src') || null;

      //   if(issue_desc && issue_type){
      //     isValid = true;
      //    requestData.issue_type = "fit_problem";
      //    requestData.fit_problem.issue_description = issue_desc;
      //    requestData.fit_problem.type = issue_type;
      //    requestData.fit_problem.image = issue_img;
      //     console.log("requestData.fit_problem.image",requestData.fit_problem.image);
      //   }else{
      //     isValid = false;
      //      if(!issue_desc){
      //        alert("Please write your issue");
      //      }else if(!issue_type){
      //        alert("Please simply draw on specific areas on the heatmap");
      //      }
      //   }
         
      //  }else if(select_issue_val.includes('quality')){
      //    // console.log('hiii get qauality')

      //    var problems = [];
      //    var issue_desc = $(this).parents('.sub-request-summary').find('.sub-request-image-input .sub-request-image-item .details-input textarea').val();
      //    var fileInput = $(this).parents('.sub-request-summary').find('.sub-request-image-input .sub-request-image-item input#image_file').val();

      //    $(this).parents('.sub-request-summary').find('.sub-request-image-input .sub-request-image-item .form-input-list input[type="checkbox"]:checked').each(function(){
      //      var check_value = $(this).siblings('span').find('span').text();
      //      problems.push(check_value);
      //    }); 

      //   var problems = {};
      //   var issue_desc = $(this).parents('.sub-request-summary').find('.sub-request-image-input .sub-request-image-item .details-input textarea').val() || null;
      //   // var fileInput = $(this).parents('.sub-request-summary').find('.sub-request-image-input .sub-request-image-item input#image_file').val() || null;
      //    // var files = $(this) .parents('.sub-request-summary') .find('.sub-request-image-input .sub-request-image-item input[type="file"]')[0].files;

      //    var fileInputEl = $(this).parents('.sub-request-summary').find('.sub-request-image-input .sub-request-image-item input[type="file"]')[0];
      //     var files = fileInputEl?.files || [];


      //   $(this).parents('.sub-request-summary').find('.sub-request-image-input .sub-request-image-item .form-input-list input[type="checkbox"]:checked').each(function (index) {
      //       var check_value = $(this).siblings('span').find('span').text();
      //       problems[`issue${index + 1}`] = check_value;
      //   });

      //   if(issue_desc && Object.keys(problems).length > 0){
      //     isValid = true;
      //     requestData.issue_type = "quality_problem";
      //     requestData.quality_problem.issue_description = issue_desc;
      //     requestData.quality_problem.problem = problems;
      //      // requestData.quality_problem.image = fileInput;
      //     requestData.quality_problem.images = [];
      //     // for (let i = 0; i < files.length; i++) {
      //     //     requestData.quality_problem.images.push(files[i]);
      //     // }

      //       const promises = [];
      //       for (let i = 0; i < files.length; i++) {
      //         promises.push(readFileAsBase64(files[i]));
      //       }

      //        Promise.all(promises).then(base64Array => {
      //         // Option 1: Send base64 strings (without headers)
      //         // requestData.quality_problem.images = base64Array.map(b64 => b64.split(',')[1]);
          
      //         // ✅ Option 2 (Better): Send full Data URLs (base64 with MIME type)
      //         requestData.quality_problem.images = base64Array;
          
      //         // Now submit requestData only after all images are ready
      //         console.log('Final requestData:', requestData);
          
      //         // // Call your API here
      //         // submitRequestData(requestData);
      //       });
          
      //       function readFileAsBase64(file) {
      //         return new Promise((resolve, reject) => {
      //           const reader = new FileReader();
      //           reader.onload = () => resolve(reader.result); // keep full data URL
      //           reader.onerror = error => reject(error);
      //           reader.readAsDataURL(file);
      //         });
      //       }

      //   }else{
      //     isValid = false;
      //     if(!issue_desc){
      //       alert("Please Write your issue");
      //     }else if(!Object.keys(problems).length > 0){
      //       alert("Please select the quality problem you observed");
      //     }else if(!files.length > 0){
      //       alert("Please upload clear photos showing the defect.")
      //     }
      //   }      
      //  }else if(select_issue_val.includes('other')){
      //    // console.log('hiii get other')
      //  }

      //  console.log('data',requestData);

    
       
      //  // Sending the JSON data to the API
      // // fetch("https://445d-128-251-131-33.ngrok-free.app/shopify/order/cancel_line", {
      // //     method: "POST",
      // //     headers: {
      // //         "Content-Type": "application/json"
      // //     },
      // //     body: JSON.stringify(requestData)
      // // })
      // // .then(response => response.json())
      // // .then(data => {
      // //     console.log("Response from API:", data);
      // // })
      // // .catch(error => {
      // //     console.error("Error sending data:", error);
      // // });
      // if(isValid == true){
        
      
      //   $.ajax({
      //       url: "https://app.footprint-pioneers.com/shopify/order/cancel_line",
      //       type: "POST",
      //       contentType: "application/json",
      //       data: JSON.stringify(requestData),
      //       success: function (response) {
      //           console.log("Response from API:", response);
      //       },
      //       error: function (xhr, status, error) {
      //           console.error("Error sending data:", error);
      //       }
      //   });
  
      //   $(".order-action-details").css("display","none");
      //   $(".order-actions-result").removeClass('hidden');
      //   $(".order-actions-result").css("display", "block");
      // }
       requestData = {
    "order_id": order_id,
    "line_item_id": item_id,
    "issue_type": "other",
    "fit_problem": {
        "issue_description": null,
        "type": null,
        "image": null
    },
    "quality_problem": {
        "issue_description": null,
        "problem": {},
        "image": []
    },
    "other_issue": {
        "issue_description": null,
        "key1": {}
    }
};

var isValid = false;

if (select_issue_val.includes('fit')) {
    var issue_desc = $(this).parents('.sub-request-summary').find('.sub-request-input .input-grid-item-wrap textarea').val() || null;
    var issue_type = $(this).parents('.sub-request-summary').find('.sub-request-image-input .input-selection input[type="radio"]:checked').next('.label-input').text() || null;
    var issue_img = $(this).parents('.sub-request-summary').find('.sub-request-image-input .request-image-wrap img').attr('src') || null;

    if (issue_desc && issue_type) {
        isValid = true;
        requestData.issue_type = "fit_problem";
        requestData.fit_problem.issue_description = issue_desc;
        requestData.fit_problem.type = issue_type;
        requestData.fit_problem.image = issue_img;
        sendRequest(); // ✅ Safe to call immediately
    } else {
        if (!issue_desc) alert(fpT('writeIssue', 'Please write your issue'));
        else if (!issue_type) alert(fpT('drawHeatmap', 'Please simply draw on specific areas on the heatmap'));
    }

} else if (select_issue_val.includes('quality')) {
    var problems = {};
    var issue_desc = $(this).parents('.sub-request-summary').find('.sub-request-image-input .sub-request-image-item .details-input textarea').val() || null;
    var fileInputEl = $(this).parents('.sub-request-summary').find('.sub-request-image-input .sub-request-image-item input[type="file"]')[0];
    var files = fileInputEl?.files || [];

    $(this).parents('.sub-request-summary').find('.sub-request-image-input .sub-request-image-item .form-input-list input[type="checkbox"]:checked').each(function (index) {
        var check_value = $(this).siblings('span').find('span').text();
        problems[`issue${index + 1}`] = check_value;
    });

    if (issue_desc && Object.keys(problems).length > 0 && files.length > 0) {
        isValid = true;
        requestData.issue_type = "quality_problem";
        requestData.quality_problem.issue_description = issue_desc;
        requestData.quality_problem.problem = problems;

        // Read files as base64
        const promises = [];
        for (let i = 0; i < files.length; i++) {
            promises.push(readFileAsBase64(files[i]));
        }

        Promise.all(promises).then(base64Array => {
            requestData.quality_problem.image = base64Array;
            console.log("Final requestData with base64 images:", requestData);
            sendRequest(); // ✅ Call only after images are loaded
        });

        function readFileAsBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result); // data:image/png;base64,...
                reader.onerror = error => reject(error);
                reader.readAsDataURL(file);
            });
        }

    } else {
        if (!issue_desc) alert(fpT('writeIssue', 'Please write your issue'));
        else if (Object.keys(problems).length === 0) alert(fpT('selectQuality', 'Please select the quality problem you observed'));
        else if (files.length === 0) alert(fpT('uploadPhotos', 'Please upload clear photos showing the defect.'));
    }

} else if (select_issue_val.includes('other')) {
    // Add logic for "other" if needed
}

// ✅ Shared AJAX function
function sendRequest() {
    $.ajax({
        url: "https://app.footprint-pioneers.com/shopify/order/cancel_line",
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(requestData),
        success: function (response) {
            console.log("Response from API:", response);
            $(".order-action-details").css("display", "none");
            $(".order-actions-result").removeClass('hidden');
            $(".order-actions-result").css("display", "block");
        },
        error: function (xhr, status, error) {
            console.error("Error sending data:", error);
        }
    });
}

     });


      $('.order-main .order-actions-wrap .order-actions-result .confirmation-grid-item .see_return_details_btn').on('click',function(e){
        e.preventDefault();
        $(".order-action-confirmation").css("display", "none");
        $('.order-action-summary').css("display", "block");
        let selectedIssue = null;
        console.log("request fetch",requestData);

        var $resultImageElem =  $(".order-actions-result .summary-image-main .summary-image-wrap img");
        var $summaryInput = $(".order-actions-result .summary-details .summary-data-input");
        var $issueTitle = $(".order-actions-result .summary-details .summary-state p");
        
        if (requestData.issue_type === "quality_problem") {
          var qualityData = requestData.quality_problem;

          $issueTitle.text(fpT('qualityProblem', 'Quality Problem'));
          if (Array.isArray(qualityData.image) && qualityData.image.length > 0) {
            var firstImage = qualityData.image[0];
             $resultImageElem.attr("src", firstImage);
          }else{
           $(".order-actions-result .summary-image-main").remove();
          }
    
          var $descParagraph = $summaryInput.find("p");
          $descParagraph.text(qualityData.issue_description || "");
    
          $summaryInput.find("ul.problem-list").remove();

          if (qualityData.problem && typeof qualityData.problem === "object") {
            var $ul = $('<ul class="problem-list"></ul>');
        
            Object.values(qualityData.problem).forEach(function(problemValue) {
              var $li = $("<li></li>").text(problemValue);
              $ul.append($li);
            });
        
            // Insert the UL before the description <p>
            $descParagraph.before($ul);
          }
        }else if(requestData.issue_type === "fit_problem"){
          var fitProblem = requestData.fit_problem;
          $issueTitle.text(fpT('fitProblem', 'Fit Problem')); 
          
          if(fitProblem.image){
           $resultImageElem.attr("src",fitProblem.image);
          }else{
            $(".order-actions-result .summary-image-main").remove();
          }
          var $descParagraph = $summaryInput.find("p");
          $descParagraph.text(fitProblem.issue_description || "");
          // $(".order-actions-result .summary-image-main .summary-image-wrap img").attr('src', requestData.fit_problem.image);  
        }else{
          var otherIssue = requestData.other_issue;
          $issueTitle.text(fpT('otherIssue', 'Other Issue')); 

          $(".order-actions-result .summary-image-main").remove();
          var $descParagraph = $summaryInput.find("p");
          $descParagraph.text(otherIssue.issue_description || "");
           
        }

     });

    $('.order-main .order-actions-wrap .order-action-details .order-request-sub .breadcrumbs__list .breadcrumbs__link').on('click',function(){
      if($(this).attr('data-target')){
        $(this).parents('.order-request-details').find('.request-details-main').show();
        $(this).parents('.order-request-sub').hide();
      }
    });
    
    // $('.order-main .order-actions-main .change_request,').each(function())
  }


  //for custom wishlist

  var old_json = $('body').attr('data-customer-wishlist');
  console.log(old_json)

  // Check if old_json exists before processing
  if (old_json) {
    // Convert Ruby-style hash to valid JSON string
    var validJsonString = old_json.replace(/=>/g, ':').replace(/"(\w+)"\s*:/g, '"$1":');
  
    // Split if multiple objects are present
    var wishlistArray = validJsonString
      .replace(/}\s*{/g, '},{') // Add comma between objects
      .replace(/^\s*|\s*$/g, ''); // Trim
    
    wishlistArray = JSON.parse(`[${wishlistArray}]`); // Parse as array
    // Save to localStorage
    localStorage.setItem('wishlistData', JSON.stringify(wishlistArray));
  }

  
  $(document).find('.wishlist-btn').each(function(){
    $(this).on('click',function(){
     if($(this).parents('.order-summary-item').length > 0){
          var img = $(this).parents('.order-summary-grid').find('.order-summary-item.item-left .item-image-main img').attr('src');
          var title = $(this).parents('.order-summary-grid').find('.order-summary-item.item-right .item-title').text();
          var price = $(this).parents('.order-summary-grid').find('.order-summary-item.item-right .summary-item-wrap .summary-item-main .price_column span:last').text();
          var description = $(this).parents('.order-summary-grid').find('.order-summary-item.item-right .card_description').text() || '';
          var url = $(this).parents('.order-summary-grid').find('.order-summary-item.item-right .item-title').attr('href');
          var btn_url = $(this).attr('data-href');
    
          var customer_id = $('body').attr('data-customer-id');

          var newWishlistItem = {
            image: img,
            title: title,
            price: price,
            description: description,
            url: url
          };

        // Get existing data from localStorage
        var existingData = localStorage.getItem('wishlistData');
        var wishlistData = existingData ? JSON.parse(existingData) : [];
        
        // Append the new item
        wishlistData.push(newWishlistItem);
        
        // Update localStorage
        localStorage.setItem('wishlistData', JSON.stringify(wishlistData));

       
        // Send updated wishlist to API
        var requestData = {
          customer_id: customer_id,
          wishlist: wishlistData
        };

          // requestData = {          
          //     "customer_id":customer_id,
          //     "wishlist": {
          //       "image":img,
          //       "title":title,
          //       "price":price,
          //       "description":description,
          //       "url":url
          //     }
          // };

    
          if(requestData){
            $.ajax({
                  url: "https://app.footprint-pioneers.com/shopify/wishlist/request",
                  type: "POST",
                  contentType: "application/json",
                  data: JSON.stringify(requestData),
                  success: function (response) {
                      console.log("Response from API:", response);
                     // window.location.href = btn_url;
                  },
                  error: function (xhr, status, error) {
                      console.error("Error sending data:", error);
                  }
              });
          }
     }else{
          var img = $(this).parents('.grid__item').find('.cst_card_media img').attr('src');
          var title = $(this).parents('.grid__item').find('.cst_card_content .card_title a').text();
          var price = $(this).parents('.grid__item').find('.cst_card_content .card_price').text();
          var description = $(this).parents('.grid__item').find('.cst_card_content .card_description').text();
          var url = $(this).parents('.grid__item').find('.cst_card_content .card_title a').attr('href');
          var btn_url = $(this).attr('data-href');
    
          var customer_id = $('body').attr('data-customer-id');

          var newWishlistItem = {
            image: img,
            title: title,
            price: price,
            description: description,
            url: url
          };
       
       // Get existing data from localStorage
        var existingData = localStorage.getItem('wishlistData');
        var wishlistData = existingData ? JSON.parse(existingData) : [];
        
        // Append the new item
        wishlistData.push(newWishlistItem);
        
        // Update localStorage
        localStorage.setItem('wishlistData', JSON.stringify(wishlistData));

       
        // Send updated wishlist to API
        var requestData = {
          customer_id: customer_id,
          wishlist: wishlistData
        };

    
          // requestData = {          
          //     "customer_id":customer_id,
          //     "wishlist": {
          //       "image":img,
          //       "title":title,
          //       "price":price,
          //       "description":description,
          //       "url":url
          //     },
          // };
    
          if(requestData){
            $.ajax({
                  url: "https://app.footprint-pioneers.com/shopify/wishlist/request",
                  type: "POST",
                  contentType: "application/json",
                  data: JSON.stringify(requestData),
                  success: function (response) {
                      console.log("Response from API:", response);
                     // window.location.href = btn_url;
                  },
                  error: function (xhr, status, error) {
                      console.error("Error sending data:", error);
                  }
              });
          }
     }

    });
  });


  //remove wishlist
  $(document).find('.wishlist-main .wishlist-grid-item').each(function(){
    $(this).find('.card-action-item.item-remove a').on('click',function(){
      // var index = parseInt($(this).attr('data-index'));
      var index = parseInt($(this).attr('data-index')) - 1; // convert to 0-based index
      var customer_id = $('body').attr('data-customer-id');

      var wishlistArray = JSON.parse(localStorage.getItem('wishlistData')) || [];
      if (!isNaN(index) && index >= 0 && index < wishlistArray.length) {
        wishlistArray.splice(index, 1); // remove 1 item at the given index
      }
      // Update localStorage with new wishlist
      localStorage.setItem('wishlistData', JSON.stringify(wishlistArray));
    
      var requestData = {
        customer_id: customer_id,
        wishlist: wishlistArray
      };

      // Send to API
      $.ajax({
        url: "https://app.footprint-pioneers.com/shopify/wishlist/request",
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(requestData),
        success: function (response) {
          console.log("Wishlist updated:", response);
    
          // Optional: remove the DOM element visually
          $(e.target).closest('.wishlist-grid-item').remove();
        },
        error: function (xhr, status, error) {
          console.error("Error updating wishlist:", error);
        }
      });
      
    });
  });
  
});



document.addEventListener("DOMContentLoaded", function() {
  // Get the canvas element and its 2D context
  var c = document.getElementById("heatmap-canvas");
  if(c){
  var ctx = c.getContext("2d");

  // Get the image element
  var img = document.getElementById("heatmap-image");

  // Ensure the image is loaded before drawing it on the canvas
  img.onload = function() {
      c.width = img.width;
      c.height = img.height;
      ctx.drawImage(img, 0, 0, c.width, c.height);
  };

  // If the image is already cached (loaded), trigger the onload handler
  if (img.complete) {
      img.onload();
  }

  // Initialize the heatmap instance
  var heatmapInstance = h337.create({
      container: document.querySelector('.heatmap'),
      radius: 50, // Set the marker size
      maxOpacity: 0.6,
      minOpacity: 0,
      blur: 0.85
  });

  var isHeatmapDrawn = false; // Track if heatmap data is added

  // Function to add heatmap data for "Too Narrow"
  function addTooNarrowMarker(x, y) {
      heatmapInstance.addData({
          x: x,
          y: y,
          value: 1
      });
      drawHeatmapMarker(x, y, "green");
      isHeatmapDrawn = true; // Mark that the heatmap has been updated
  }

  // Function to add heatmap data for "Too Tight"
  function addTooTightMarker(x, y) {
      heatmapInstance.addData({
          x: x,
          y: y,
          value: 1
      });
      drawHeatmapMarker(x, y, "red");
      isHeatmapDrawn = true; // Mark that the heatmap has been updated
  }

  // Function to manually draw a marker on the canvas
  function drawHeatmapMarker(x, y, color) {
      var radius = 50; // Marker radius
      ctx.beginPath();
      ctx.arc(x, y, radius, 0, Math.PI * 2, false);
      ctx.fillStyle = color === "red" ? "rgba(255, 0, 0, 0.6)" : "rgba(0, 255, 0, 0.6)"; // Red or Green for Too Narrow/Too Tight
      ctx.fill();
  }

  document.querySelector('.sub-request-image').addEventListener('click', function(ev) {
      var rect = c.getBoundingClientRect();
      var scaleX = c.width / rect.width;  // Scale factor for X
      var scaleY = c.height / rect.height; // Scale factor for Y

      var x = (ev.clientX - rect.left) * scaleX;
      var y = (ev.clientY - rect.top) * scaleY;

      if (document.getElementById('too-narrow-fit').checked) {
          addTooNarrowMarker(x, y);
      } else if (document.getElementById('too-tight-fit').checked) {
          addTooTightMarker(x, y);
      }
  });

  // Function to get the base64 image of the heatmap canvas
  function getHeatmapImage(c) {
      // Get the base64 representation of the canvas
      var base64Image = c.toDataURL();
      console.log(base64Image);  // You can log it or use it further

      // Create an image element to display the downloaded heatmap image
      var base64ImgTag = document.createElement("img");
      base64ImgTag.src = base64Image;
      // document.body.appendChild(base64ImgTag);  // Optionally append to the body to show it
      document.querySelector(".sub-request-image-input .request-image-wrap img").src = base64Image;
    
      
  }

  // Event listener for mouseleave, but only trigger if heatmap has been updated
  document.querySelector(".sub-request-image").addEventListener("mouseleave", function() {
      if (isHeatmapDrawn) {
          getHeatmapImage(c);  // Call the function to get the heatmap image
      }
  });
  }
});




$(document).ready(function() {
  // Toggle the class 'active' when clicking inside .desktop-localization-wrapper
  $('.desktop-localization-wrapper').on('click', function(e) {
    e.stopPropagation();  // Prevent event from bubbling up to the document click event
    $(this).toggleClass('active');  // Toggle 'active' class
  });

  // Prevent click event from closing when clicking inside .header__submenu
  $('.desktop-localization-wrapper .header__submenu').on('click', function(e) {
    e.stopPropagation();  // Prevent event from bubbling up to the document click event
  });

  // When clicking anywhere outside .desktop-localization-wrapper, remove the 'active' class
  $(document).on('click', function(e) {
    // Check if the click was outside the .desktop-localization-wrapper
    if (!$(e.target).closest('.desktop-localization-wrapper').length) {
      $('.desktop-localization-wrapper').removeClass('active');
    }
  });

  $('.quick-action-block .order-actions-mobile a').on('click', function(e) {
    e.stopPropagation();  // Prevent event from bubbling up to the document click event
    $('.mobile-dialog-action').addClass('active'); 
    $('body').addClass('no-scroll'); 
  });

  $('.mobile-dialog-action .close-dialog-btn').on('click', function(e) {
    e.stopPropagation();  // Prevent event from bubbling up to the document click event
    $('.mobile-dialog-action').removeClass('active');  
    $('body').removeClass('no-scroll'); 
  });

});


//Ak custom code
function accordionClickHandler(event){
  const header = event.currentTarget;
  const content = header.nextElementSibling;
  
        // const content = header.nextElementSibling;

      if (!content) return;

      const isHidden = content.hasAttribute("hidden");

      // Close all other accordions
      document.querySelectorAll(".accordion__content").forEach(el => el.setAttribute("hidden", true));
      document.querySelectorAll(".accordion-header").forEach(el => el.removeAttribute("open"));

      if (isHidden) {
        content.removeAttribute("hidden");
        header.setAttribute("open", ""); 

        if (header.getAttribute("data") === "size") {
          const firstTab = content.querySelector(".tab-link");
          if (firstTab) firstTab.click();
        }

        // Setup tab switching only inside this accordion content
        const tabLinks = content.querySelectorAll(".tab-link");
        const tabContents = content.querySelectorAll(".tab-content");

        tabLinks.forEach(link => {
          link.addEventListener("click", function (e) {
            e.preventDefault();

            const value = this.getAttribute("data-tab-value");
   
            tabLinks.forEach(l => l.classList.remove("active"));
            tabContents.forEach(c => c.setAttribute("hidden", true));

            this.classList.add("active");
            const selectedTab = content.querySelector(`#${value}`);
            if (selectedTab) selectedTab.removeAttribute("hidden");
          });
        });

      } else {
        content.setAttribute("hidden", true);
        header.removeAttribute("open"); 
      }
}
 function handleDisclosureClick(event) {
    event.stopPropagation();
    const listWrapper = this.closest(".disclosure").querySelector(".disclosure__list-wrapper");
    if (listWrapper) listWrapper.classList.toggle("hidden");
  }


function cart_cstm_size_events(){

  //accorion click
  const headers = document.querySelectorAll(".cart-accordian .accordion-header");

  headers.forEach(function (header) {
    header.removeEventListener("click", accordionClickHandler); // remove old
    header.addEventListener("click", accordionClickHandler);    // add fresh
  });



  //items other js  
    var cart_items = document.querySelectorAll(".cart-items .cart-item");

    if (cart_items.length) {
        cart_items.forEach((cart_item) => {
            // Handle Tabs per cart-item
            const tabs = cart_item.querySelectorAll(".tab-link");
            const tabContents = cart_item.querySelectorAll(".tab-content");

            tabs.forEach(tab => {
                tab.addEventListener("click", function () {
                    const tabValue = this.getAttribute("data-tab-value");

                    tabs.forEach(t => t.classList.remove("active"));
                    tabContents.forEach(content => content.classList.remove("active"));

                    this.classList.add("active");
                    cart_item.querySelector(`.tab-content[data-tab-info="${tabValue}"]`).classList.add("active");
                    window.fpClarity?.track('cart_size_tab_selected', {
                      cart_size_tab: tabValue === 'tab2' ? 'standard' : 'scan',
                    });
                });
            });

            // Handle size dropdown
            var disclosure = cart_item.querySelector(".disclosure");
       
            if (disclosure) {
                var disclosure_button = disclosure.querySelector(".disclosure__button");
                var listWrapper = disclosure.querySelector(".disclosure__list-wrapper");
                var inputField = cart_item.querySelector("input.form_standard-size");

                // disclosure_button.addEventListener("click", function (event) {
                //     event.stopPropagation();
                //     listWrapper.classList.toggle("hidden");
                // });
                disclosure_button.removeEventListener("click", handleDisclosureClick); // remove old
                disclosure_button.addEventListener("click", handleDisclosureClick);   // add new

                disclosure.querySelectorAll(".disclosure__list-wrapper li").forEach((disclosure_item) => {
                    disclosure_item.addEventListener("click", function () {
                        listWrapper.classList.add("hidden");
                        var selectedVal = this.getAttribute("data-list-value");

                        if (inputField) {
                            inputField.value = selectedVal;
                            updateCartProperties(cart_item, selectedVal);
                        }

                        disclosure_button.querySelector("span").textContent = selectedVal;
                        window.fpClarity?.track('cart_standard_size_selected', {
                          cart_standard_size: selectedVal,
                        });

                        // ✅ Add 'active' to only this cart-accordian
                        var accordianWrapper = disclosure.closest(".cart-accordian");
                        if (accordianWrapper) {
                            accordianWrapper.classList.add("active");
                        }

                        // ✅ Enable button only if all size inputs are filled
                        var allInputs = document.querySelectorAll(".form_standard-size");
                        if(allInputs.length){
                          var allFilled = Array.from(allInputs).every(input => input.value.trim() !== "");
                          var cartCtas = document.querySelector(".cart__footer .cart__ctas");
  
                  
                          // if (allFilled) {
                          //   cartCtas.removeAttribute("disabled");
                          //   console.log("Attribute removed.....");
                          // } else {
                          //   cartCtas.setAttribute("disabled", "disabled");
                          //   console.log("Attribute setted...");
                          // }
                        }else{
                           cartCtas.removeAttribute("disabled");
                          console.log("Attribute removed.....");
                        }
                        

                        //Ak custom code
                        const cartItems = document.querySelectorAll('.cart-item.cst-cart-item:not(.gift-product)');
                        const totalItems = cartItems.length;
                        const activeCount = [...cartItems].filter(item =>
                          item.querySelector('.cart-accordian.size_accordion.active')
                        ).length;
                          if(activeCount){
                             if (activeCount === totalItems && totalItems > 0) {
                                cartCtas.removeAttribute('disabled');
                              } else {
                                cartCtas.setAttribute('disabled', 'disabled');
                              }
                          }else{
                            const giftcount = document.querySelectorAll(".cart-item.cst-cart-item.gift-product");
                            if(totalItems == giftcount.length){
                              submitButton.setAttribute('disabled', 'disabled');
                            }else{
                              submitButton.removeAttribute('disabled');
                            }
                          }
                        //End Ak custom code

                    });
                });

                // Close dropdown if clicked outside
                document.addEventListener("click", function (event) {
                    if (!disclosure.contains(event.target)) {
                      listWrapper.classList.add("hidden");
                    }
                });
            }
        });
    }
  //end other js



  //Ak custom code
  if(document.body.classList.contains('template-cart')|| document.body.classList.contains('template-order')){
  
    //on load and on scan item click 
    const submitButton = document.querySelector('.cart__footer .cart__ctas'); // Adjust if needed
  
    function updateButtonState() {
        const cartItems = document.querySelectorAll('.cart-item.cst-cart-item');
        const nonGiftItems = document.querySelectorAll('.cart-item.cst-cart-item:not(.gift-product)');
        const measurementHint = document.getElementById('measurement-hint');
      
        const totalNonGift = nonGiftItems.length;
      
        if (totalNonGift === 0) {
          // All items are gift products — enable the button
          submitButton.removeAttribute('disabled');
          if (measurementHint) measurementHint.style.display = 'none';
          console.log("Only gift items — button enabled");
        } else {
          // At least one non-gift product exists
          const activeCount = [...nonGiftItems].filter(item =>
            item.querySelector('.cart-accordian.size_accordion.active')
          ).length;
      
          // if (activeCount === totalNonGift) {
          //   // All non-gift items have active size accordion — enable
          //   submitButton.removeAttribute('disabled');
          //   if (measurementHint) measurementHint.style.display = 'none';
          //   console.log("All non-gift items selected — button enabled");
          // } else {
          //   // Some non-gift items missing selection — disable
          //   submitButton.setAttribute('disabled', 'disabled');
          //   if (measurementHint) measurementHint.style.display = 'block';
          //   console.log("Missing selections — button disabled");
          // }
        }
    }

  
  
    function updateCartItemProperties(lineIndex, newProps = {}) {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const item = cart.items[lineIndex];
          if (!item) return;
    
          const existingProps = item.properties || {};
    
          // Create a copy and update relevant fields
          const updatedProps = { ...existingProps };
    
          // Remove old standard size props
          delete updatedProps.form_standard_size;
          delete updatedProps.form_standard_size_left;
          delete updatedProps.form_standard_size_right;
    
          // Add new ones
          Object.assign(updatedProps, newProps);
    
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              line: lineIndex + 1, // Shopify's line index starts from 1
              quantity: item.quantity,
              properties: updatedProps
            })
          })
          .then(res => res.json())
          .then(data => {
            console.log('Cart updated with merged properties:', data);
          })
          .catch(err => {
            console.error('Error updating cart item:', err);
          });
        });
    }

  
    document.querySelectorAll('.cart-item.cst-cart-item').forEach((cartItem, index) => {
      const wraps = cartItem.querySelectorAll('.my-scans-wrap');
  
      wraps.forEach(wrap => {
       wrap.addEventListener('click', () => {
        wraps.forEach(w => w.querySelector('.my-scans-item').classList.remove('active'));
        const activeItem = wrap.querySelector('.my-scans-item');
        if (activeItem) activeItem.classList.add('active');

        // Add `active` class to the parent cart item accordion
        const cartAccordion = wrap.closest('.cart-accordian.accordion');
        if (cartAccordion) {
          cartAccordion.classList.add('active');
        }
      
        const leftSize = wrap.getAttribute('data-left-size');
        const rightSize = wrap.getAttribute('data-right-size');

         
      
        let newProps = {};
        // if (leftSize === rightSize) {
        //   newProps["form_standard_size"] = leftSize;
        // } else {
        //   newProps["form_standard_size_left"] = leftSize;
        //   newProps["form_standard_size_right"] = rightSize;
        // }

        const measure_id = wrap.getAttribute('data-measure-id');
         if(measure_id){
           newProps["form_standard_measure_id"] = measure_id;
         }
         //   newProps["form_standard_size"] = leftSize;
         
      
        updateCartItemProperties(index, newProps);
        updateButtonState();
        window.fpClarity?.track('cart_scan_selected');
      });

        
      });
    });
  
    updateButtonState(); // Check on load
    //End on load and on scan item click 

    const installButtons = document.querySelectorAll(".empty-scan-block .button[data-cust-id]");
    // if (!installButtons.length) return;
    
    installButtons.forEach((installBtn) => {
      installBtn.addEventListener("click", function (e) {
        e.preventDefault();
    
        const custId = installBtn.getAttribute("data-cust-id");
        const custEmail = installBtn.getAttribute("data-cust-email");
        const custName = installBtn.getAttribute("data-cust-email");
        const ordrLineId = installBtn.getAttribute("data-line-id");
        const ordrId = installBtn.getAttribute("data-order-id");
        if (!custId || !custEmail || !custName) return;
    
        const qrContainer = this.closest('.tab-content').querySelector('.qrcode');
        const qrContainer_cstm = this.closest('.tab-content').querySelector('.order-summary-wss .qrcode');
        //document.getElementById("qrcode");
        if (qrContainer) qrContainer.innerHTML = "";
    
        async function generateUniqueCode(id, email) {
          const randomNum = Math.floor(Math.random() * 1_000_000);
          const data = `${id}|${email}|${randomNum}`;
    
          const encoder = new TextEncoder();
          const dataBuffer = encoder.encode(data);
    
          const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
          const hashArray = Array.from(new Uint8Array(hashBuffer));
          const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
          return hashHex;
        }
    
        generateUniqueCode(custId, custEmail).then(code => {
          const urlToEncode = `https://app.footprint-pioneers.com/backend/qr?id=${custId}&name=${custName}&email=${custEmail}&qr_id=${code}`;
          const urlToEncodecstm = `https://app.footprint-pioneers.com/backend/qr?id=${custId}&name=${custName}&email=${custEmail}&qr_id=${code}&order_id=${ordrId}&line_id=${ordrLineId}`;
          if (qrContainer) {
            qrContainer.innerHTML = `<img src="${urlToEncode}" />`;
          }
          if (qrContainer_cstm) {
            qrContainer.innerHTML = `<img src="${urlToEncodecstm}" />`;
          }
    
          const emptyScanBlock = installBtn.closest('.empty-scan-block');
          if (emptyScanBlock) {
            emptyScanBlock.classList.add('hidden');
          }
    
          window.fpClarity?.track('cart_scan_qr_started');
          pollUserDetail(this,code); // This function will poll the server until status is 1
        });
      });
    });

    const scan_plus_buttons = document.querySelectorAll(".my-scans .more-scan-btn[data-cust-id]");
    scan_plus_buttons.forEach((scan_btn) => {
      scan_btn.addEventListener("click", function (e) {
        e.preventDefault();
    
        const custId = scan_btn.getAttribute("data-cust-id");
        const custEmail = scan_btn.getAttribute("data-cust-email");
        const custName = scan_btn.getAttribute("data-cust-email");
        const ordrLineId = scan_btn.getAttribute("data-line-id");
        const ordrId = scan_btn.getAttribute("data-order-id");
        if (!custId || !custEmail || !custName) return;
    
        const qrContainer = this.closest('.tab-content').querySelector('.qrcode');
        const qrContainer_cstm = this.closest('.tab-content').querySelector('.order-summary-wss .qrcode');
        //document.getElementById("qrcode");
        if (qrContainer) qrContainer.innerHTML = "";
    
        async function generateUniqueCode(id, email) {
          const randomNum = Math.floor(Math.random() * 1_000_000);
          const data = `${id}|${email}|${randomNum}`;
    
          const encoder = new TextEncoder();
          const dataBuffer = encoder.encode(data);
    
          const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
          const hashArray = Array.from(new Uint8Array(hashBuffer));
          const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
          return hashHex;
        }
    
        generateUniqueCode(custId, custEmail).then(code => {
          const urlToEncode = `https://app.footprint-pioneers.com/backend/qr?id=${custId}&name=${custName}&email=${custEmail}&qr_id=${code}`;
          const urlToEncodecstm = `https://app.footprint-pioneers.com/backend/qr?id=${custId}&name=${custName}&email=${custEmail}&qr_id=${code}&order_id=${ordrId}&line_id=${ordrLineId}`;
          if (qrContainer) {
            qrContainer.innerHTML = `<img src="${urlToEncode}" />`;
          }
          if (qrContainer_cstm) {
            qrContainer.innerHTML = `<img src="${urlToEncodecstm}" />`;
          }
    
          // const emptyScanBlock = installBtn.closest('.empty-scan-block');
          // if (emptyScanBlock) {
          //   emptyScanBlock.classList.add('hidden');
          // }
    
          window.fpClarity?.track('cart_scan_qr_started');
          pollUserDetail(this,code); // This function will poll the server until status is 1
        });
      });
    });

    //calling api
    function pollUserDetail(this_is,code, interval = 3000, maxAttempts = 100000) {
      let attempts = 0;
    
      const poll = () => {
        fetch('https://app.footprint-pioneers.com/backend/get_user_detail', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ code })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Polling response:', data);
          var data_status = data?.result?.user?.status || 0;
          if (data_status == 1) {
            console.log("Data ready:", data);
            window.fpClarity?.track('cart_scan_completed');
            // location.reload();
            // You can do something here like update the UI, stop loading spinner, etc.
            //refresh data
            const sizeAccordionEl = this_is.closest('.cart-accordian.size_accordion');
            if (!sizeAccordionEl) return;
          
            // Find index of the current cart-accordian
            const allAccordions = [...document.querySelectorAll('.cart-accordian.size_accordion')];
            const targetIndex = allAccordions.indexOf(sizeAccordionEl);
            if (targetIndex === -1) return;
            
            fetch(window.location.pathname)  // Replace section_id with your section
            .then(response => response.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
    
              // Get same indexed item from the new content
              const refreshedAccordions = doc.querySelectorAll('.cart-accordian.size_accordion');
              const newContent = refreshedAccordions[targetIndex];
              const contentWrapper = allAccordions[targetIndex];
              contentWrapper.classList.remove('active');
        
              if (newContent && contentWrapper) {
                contentWrapper.innerHTML = newContent.innerHTML;
    
                // Re-init your scripts or event bindings here
                cart_cstm_size_events();
    
                const accordion = contentWrapper.querySelector('.accordion-header');
                if(accordion){
                  accordion.click();
                }
              }
              
            })
            .catch(error => {
              console.error('AJAX load failed:', error);
            });
            //End Refresh data
            
          } else {
            attempts++;
            if (attempts < maxAttempts) {
              setTimeout(poll, interval); // Try again after `interval` ms
            } else {
              console.warn("Max attempts reached without getting status 1");
            }
          }
          
        })
        .catch(error => {
          console.error("Error during polling:", error);
          // You may want to retry even on error, or stop
        });
      };
    
      poll();
    }

    
  }
  //Ak custom code
  
}

if(document.body.classList.contains('template-account')){
  function add_measure_event(){
    // Handle "Add new measurements" button (for users who already have scans)
    const add_measures = document.querySelectorAll(".scan-item.item-info .add_new_measure_account");
    add_measures.forEach((add_measure) => {
      add_measure.addEventListener("click", function (e) {
        e.preventDefault();
    
        const custId = add_measure.getAttribute("data-cust-id");
        const custEmail = add_measure.getAttribute("data-cust-email");
        const custName = add_measure.getAttribute("data-cust-email");
        if (!custId || !custEmail || !custName) return;
    
        const qrContainer = this.closest('.scan-item.item-info').querySelector('.qrcode');
        //document.getElementById("qrcode");
        if (qrContainer) qrContainer.innerHTML = "";
    
        async function generateUniqueCode(id, email) {
          const randomNum = Math.floor(Math.random() * 1_000_000);
          const data = `${id}|${email}|${randomNum}`;
    
          const encoder = new TextEncoder();
          const dataBuffer = encoder.encode(data);
    
          const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
          const hashArray = Array.from(new Uint8Array(hashBuffer));
          const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
          return hashHex;
        }
    
        generateUniqueCode(custId, custEmail).then(code => {
          const urlToEncode = `https://app.footprint-pioneers.com/backend/qr?id=${custId}&name=${custName}&email=${custEmail}&qr_id=${code}`;
          if (qrContainer) {
            qrContainer.innerHTML = `<img src="${urlToEncode}" />`;
          }
          
          add_measure.classList.add('hidden');
          // const emptyScanBlock = installBtn.closest('.empty-scan-block');
          // if (emptyScanBlock) {
          //   emptyScanBlock.classList.add('hidden');
          // }
    
          pollUserDetailaccount(this,code); // This function will poll the server until status is 1
        });
      });
    });
  }

  // Handle Install button for users with no scans (My measurements page - desktop only)
  function add_initial_measure_event(){
    const installButtons = document.querySelectorAll(".how-to-measure .desktop-only .empty-scan-block .button[data-cust-id]");
    installButtons.forEach((installBtn) => {
      installBtn.addEventListener("click", function (e) {
        e.preventDefault();
    
        const custId = installBtn.getAttribute("data-cust-id");
        const custEmail = installBtn.getAttribute("data-cust-email");
        const custName = installBtn.getAttribute("data-cust-name");
        if (!custId || !custEmail) {
          console.error('Missing critical customer data (ID or email)!');
          return;
        }
        // Use email as name if name is empty
        const customerName = custName || custEmail.split('@')[0];
    
        const qrContainer = this.closest('.empty-scan-block').querySelector('.qrcode');
        if (qrContainer) qrContainer.innerHTML = "";
    
        async function generateUniqueCode(id, email) {
          const randomNum = Math.floor(Math.random() * 1_000_000);
          const data = `${id}|${email}|${randomNum}`;
    
          const encoder = new TextEncoder();
          const dataBuffer = encoder.encode(data);
    
          const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
          const hashArray = Array.from(new Uint8Array(hashBuffer));
          const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
          return hashHex;
        }
    
        generateUniqueCode(custId, custEmail).then(code => {
          const urlToEncode = `https://app.footprint-pioneers.com/backend/qr?id=${custId}&name=${customerName}&email=${custEmail}&qr_id=${code}`;
          if (qrContainer) {
            qrContainer.innerHTML = `<img src="${urlToEncode}" />`;
          }
    
          installBtn.style.display = 'none';
    
          pollUserDetailaccount(this,code); // This function will poll the server until status is 1
        }).catch(error => {
          console.error('Error in generateUniqueCode:', error);
        });
      });
    });
  }

  //on load measure btn
  add_measure_event();
  add_initial_measure_event();
  
    //calling api
    function pollUserDetailaccount(this_is,code, interval = 3000, maxAttempts = 100000) {
      let attempts = 0;
    
      const poll = () => {
        fetch('https://app.footprint-pioneers.com/backend/get_user_detail', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ code })
        })
        .then(response => response.json())
        .then(data => {
          // console.log('Polling response:', data);
          var data_status = data?.result?.user?.status || 0;
          if (data_status == 1) {
            console.log("Data ready:", data);
            // location.reload();
            // You can do something here like update the UI, stop loading spinner, etc.
            //refresh data
            const sizeAccordionEl = this_is.closest('.scan-item-grid');
            if (!sizeAccordionEl) return;
          
            // Find index of the current cart-accordian
            const allAccordions = [...document.querySelectorAll('.scan-item-grid')];
            const targetIndex = allAccordions.indexOf(sizeAccordionEl);
            if (targetIndex === -1) return;
            
            fetch(window.location.pathname)  // Replace section_id with your section
            .then(response => response.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
    
              // Get same indexed item from the new content
              const refreshedAccordions = doc.querySelectorAll('.scan-item-grid');
              const newContent = refreshedAccordions[targetIndex];
              const contentWrapper = allAccordions[targetIndex];
              // contentWrapper.classList.remove('active');
        
              if (newContent && contentWrapper) {
                contentWrapper.innerHTML = newContent.innerHTML;
    
                // Re-init your scripts or event bindings here
                add_measure_event();
    
                // const accordion = contentWrapper.querySelector('.accordion-header');
                // if(accordion){
                //   accordion.click();
                // }
              }
              
            })
            .catch(error => {
              console.error('AJAX load failed:', error);
            });
            //End Refresh data
            
          } else {
            attempts++;
            if (attempts < maxAttempts) {
              setTimeout(poll, interval); // Try again after `interval` ms
            } else {
              console.warn("Max attempts reached without getting status 1");
            }
          }

          
        })
        .catch(error => {
          console.error("Error during polling:", error);
          // You may want to retry even on error, or stop
        });
      };
    
      poll();
    }
  
}



//End Ak custom code
document.addEventListener("DOMContentLoaded", function () {
  cart_cstm_size_events();
  // const headers = document.querySelectorAll(".cart-accordian .accordion-header");

  // headers.forEach(function (header) {
  //   header.addEventListener("click", function () {
  //     const content = header.nextElementSibling;

  //     if (!content) return;

  //     const isHidden = content.hasAttribute("hidden");

  //     // Close all other accordions
  //     document.querySelectorAll(".accordion__content").forEach(el => el.setAttribute("hidden", true));
  //     document.querySelectorAll(".accordion-header").forEach(el => el.removeAttribute("open"));

  //     if (isHidden) {
  //       content.removeAttribute("hidden");
  //       header.setAttribute("open", ""); 

  //       if (header.getAttribute("data") === "size") {
  //         const firstTab = content.querySelector(".tab-link");
  //         if (firstTab) firstTab.click();
  //       }

  //       // Setup tab switching only inside this accordion content
  //       const tabLinks = content.querySelectorAll(".tab-link");
  //       const tabContents = content.querySelectorAll(".tab-content");

  //       tabLinks.forEach(link => {
  //         link.addEventListener("click", function (e) {
  //           e.preventDefault();

  //           const value = this.getAttribute("data-tab-value");
   
  //           tabLinks.forEach(l => l.classList.remove("active"));
  //           tabContents.forEach(c => c.setAttribute("hidden", true));

  //           this.classList.add("active");
  //           const selectedTab = content.querySelector(`#${value}`);
  //           if (selectedTab) selectedTab.removeAttribute("hidden");
  //         });
  //       });

  //     } else {
  //       content.setAttribute("hidden", true);
  //       header.removeAttribute("open"); 
  //     }
  //   });
  // });
});


// document.addEventListener('DOMContentLoaded', function () {
//     var cart_items = document.querySelectorAll(".cart-items .cart-item");

//     if (cart_items.length) {
//         cart_items.forEach((cart_item) => {
//             var disclosure = cart_item.querySelector(".disclosure");
            
//             if (disclosure) {
//                 var disclosure_button = disclosure.querySelector(".disclosure__button");
//                 var listWrapper = disclosure.querySelector(".disclosure__list-wrapper");

//                 disclosure_button.addEventListener('click', function (event) {
//                     event.stopPropagation(); // Prevent event from bubbling up
//                     listWrapper.classList.toggle("hidden");
//                 });

//                 disclosure.querySelectorAll(".disclosure__list-wrapper li").forEach((disclosure_item) => {
//                     disclosure_item.addEventListener('click', function () {
//                         listWrapper.classList.add('hidden');
//                         var selectedVal = this.getAttribute("data-list-value");
//                        cart_item.querySelector("input.form_standard-size").value = selectedVal;
//                         disclosure_button.querySelector("span").textContent = selectedVal;
//                     });
//                 });

//                 // Click outside to close the dropdown
//                 document.addEventListener('click', function (event) {
//                     if (!disclosure.contains(event.target)) {
//                         listWrapper.classList.add('hidden');
//                     }
//                 });
//             }
//         });
//     }
// });



document.addEventListener("DOMContentLoaded", function () {
    // var cart_items = document.querySelectorAll(".cart-items .cart-item");

    // if (cart_items.length) {
    //     cart_items.forEach((cart_item) => {
    //         // Handle Tabs per cart-item
    //         const tabs = cart_item.querySelectorAll(".tab-link");
    //         const tabContents = cart_item.querySelectorAll(".tab-content");

    //         tabs.forEach(tab => {
    //             tab.addEventListener("click", function () {
    //                 const tabValue = this.getAttribute("data-tab-value");

    //                 tabs.forEach(t => t.classList.remove("active"));
    //                 tabContents.forEach(content => content.classList.remove("active"));

    //                 this.classList.add("active");
    //                 cart_item.querySelector(`.tab-content[data-tab-info="${tabValue}"]`).classList.add("active");
    //             });
    //         });

    //         // Handle size dropdown
    //         var disclosure = cart_item.querySelector(".disclosure");

    //         if (disclosure) {
    //             var disclosure_button = disclosure.querySelector(".disclosure__button");
    //             var listWrapper = disclosure.querySelector(".disclosure__list-wrapper");
    //             var inputField = cart_item.querySelector("input.form_standard-size");

    //             disclosure_button.addEventListener("click", function (event) {
    //                 event.stopPropagation();
    //                 listWrapper.classList.toggle("hidden");
    //             });

    //             disclosure.querySelectorAll(".disclosure__list-wrapper li").forEach((disclosure_item) => {
    //                 disclosure_item.addEventListener("click", function () {
    //                     listWrapper.classList.add("hidden");
    //                     var selectedVal = this.getAttribute("data-list-value");

    //                     if (inputField) {
    //                         inputField.value = selectedVal;
    //                         updateCartProperties(cart_item, selectedVal);
    //                     }

    //                     disclosure_button.querySelector("span").textContent = selectedVal;

    //                     // ✅ Add 'active' to only this cart-accordian
    //                     var accordianWrapper = disclosure.closest(".cart-accordian");
    //                     if (accordianWrapper) {
    //                         accordianWrapper.classList.add("active");
    //                     }

    //                     // ✅ Enable button only if all size inputs are filled
    //                     var allInputs = document.querySelectorAll(".form_standard-size");
    //                     var allFilled = Array.from(allInputs).every(input => input.value.trim() !== "");
    //                     var cartCtas = document.querySelector(".cart__footer .cart__ctas");

                
    //                     if (allFilled) {
    //                         cartCtas.removeAttribute("disabled");
    //                     } else {
    //                         cartCtas.setAttribute("disabled", "disabled");
    //                     }


    //                     //Ak custom code
    //                     const cartItems = document.querySelectorAll('.cart-item.cst-cart-item');
    //                     const totalItems = cartItems.length;
    //                     const activeCount = [...cartItems].filter(item =>
    //                       item.querySelector('.cart-accordian.size_accordion.active')
    //                     ).length;
                    
    //                     if (activeCount === totalItems && totalItems > 0) {
    //                       cartCtas.removeAttribute('disabled');
    //                     } else {
    //                       cartCtas.setAttribute('disabled', 'disabled');
    //                     }
    //                     //End Ak custom code

    //                 });
    //             });

    //             // Close dropdown if clicked outside
    //             document.addEventListener("click", function (event) {
    //                 if (!disclosure.contains(event.target)) {
    //                     listWrapper.classList.add("hidden");
    //                 }
    //             });
    //         }
    //     });
    // }
});

/**
 * Function to update cart properties via Shopify's cart/update.js API
 */
function updateCartProperties(cartItem, selectedVal) {
    var itemKey = cartItem.getAttribute("data-item-id"); // Unique cart item key

    if (!itemKey) {
        return;
    }

    console.log("Updating cart for itemKey:", itemKey, "with value:", selectedVal);

    fetch("/cart.json")
        .then((res) => res.json())
        .then((cartData) => {
          console.log("cartData",cartData);
            let cartItemData = cartData.items.find((item) => item.variant_id == itemKey);

            if (!cartItemData) {
                console.error("Error: Item not found in cart.");
                return;
            }
            // Merge existing properties with the new one
            let updatedProperties = { ...cartItemData.properties, form_standard_size: selectedVal };
            var formData = {
                id: itemKey, // Use `id` for cart/change.js
                quantity: cartItemData.quantity, // Preserve the existing quantity
                properties: updatedProperties, // Keep existing properties and add new one
            };

            fetch("/cart/change.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            })
            .then((response) => response.json())
            .then((data) => {
                console.log("Cart updated successfully:", data);
            })
            .catch((error) => {
                console.error("Error updating cart:", error);
            });
        })
        .catch((error) => {
            console.error("Error fetching cart data:", error);
        });
}

document.addEventListener('DOMContentLoaded', function () {
  /* Hier stand die Verdrahtung des Hinweisfensters vor der Kasse:
     eine Attrappe oeffnete es, erst sein Knopf loeste den echten
     Kaufknopf aus. Das Fenster ist entfernt, der echte Knopf ist ein
     gewoehnliches submit im Warenkorb-Formular und braucht kein
     JavaScript.

     Geblieben ist die Messung der Stufe zwischen Warenkorb und Kasse.
     Ohne sie klaffte im Trichter eine Luecke genau dort, wo bisher
     checkout_continued lag. */
  document.querySelectorAll('.cart__checkout-button').forEach(function (knopf) {
    knopf.addEventListener('click', function () {
      window.fpClarity?.track('checkout_continued');
    });
  });
});
document.addEventListener('DOMContentLoaded', function () {
  if(document.body.classList.contains('template-order')){
    const order_id = document.querySelector(".account__content .order-main").getAttribute("data-order-id");
    const formData = new FormData();
    formData.append('shopify_order_id', order_id);
  

    fetch('https://app.footprint-pioneers.com/shopify/order/info', {
      method: 'POST',
      body: formData, // Don't set Content-Type manually!
    })
    .then(response => response.json())
    .then(data => {
      console.log('Response from API:', data);
      const requestButtons = document.querySelectorAll(".line_item_click_action .change_request");
      if(data && requestButtons.length > 0){
        requestButtons.forEach((reqButton) => {
          const lineId = reqButton.getAttribute("data-line-id");
          // console.log("Line Ids",data?.data?.line_ids);
          const matchingLineItem = data?.data?.line_ids?.find(item => item.shopify_line_id == lineId);
          console.log("matchingLineItem",matchingLineItem);
          if (matchingLineItem) {
            const {
              state,
              refund_approve_message,
              cancel_fit_problem,
              cancel_quality_problem,
              cancel_other_reason
            } = matchingLineItem;
console.log("state",state);
            if(state){
              reqButton.classList.add("disabled");
              if(state == 'Return Requested'){
                reqButton.textContent = fpT('returnRequested', state);
              }else{
                 reqButton.textContent = state;
              }
            }else{
              reqButton.classList.remove("disabled");
              reqButton.textContent = fpT('changeRequest', 'Change request ->')
            }
        
            // if (refund_approve_message === true) {
            //   reqButton.textContent = 'Return Request Accepted';
            // } else if (cancel_fit_problem || cancel_quality_problem || cancel_other_reason) {
            //   reqButton.textContent = 'Request Sended';
            // }

            if(state == 'Return Requested'){
              const orderMain = document.querySelector(".order-main");
              orderMain.querySelector(".order-summary-main").style.display = 'none';
              const actionWrap = orderMain.querySelector(".order-actions-wrap");
              actionWrap.style.display = 'block';
              actionWrap.querySelector(".order-action-select").style.display = 'none';
              actionWrap.querySelector(".order-action-details").style.display = 'none';
              actionWrap.querySelector(".order-actions-result").style.display = 'block';
              actionWrap.querySelector(".order-actions-result").classList.remove('hidden');
              actionWrap.querySelector(".order-action-confirmation").style.display = 'none';
              actionWrap.querySelector(".order-action-summary").style.display = 'block';
            }
            const cancelJson = matchingLineItem.cancel_json;
            console.log("cancelJson",cancelJson);
            const issueType = cancelJson.issue_type;

            var $resultImageElem =  $(".order-actions-result .summary-image-main .summary-image-wrap img");
            var $summaryInput = $(".order-actions-result .summary-details .summary-data-input");
            var $issueTitle = $(".order-actions-result .summary-details .summary-state p");
            
            if (issueType === "quality_problem") {
              var qualityData = cancelJson.quality_problem;

              $issueTitle.text(fpT('qualityProblem', 'Quality Problem'));
              if (Array.isArray(qualityData.image) && qualityData.image.length > 0) {
                var firstImage = qualityData.image[0];
                $resultImageElem.attr("src", firstImage);
              }else{
                $(".order-actions-result .summary-image-main").remove();
              }
        
              var $descParagraph = $summaryInput.find("p");
              $descParagraph.text(qualityData.issue_description || "");
        
              $summaryInput.find("ul.problem-list").remove();

              if (qualityData.problem && typeof qualityData.problem === "object") {
                var $ul = $('<ul class="problem-list"></ul>');
            
                Object.values(qualityData.problem).forEach(function(problemValue) {
                  var $li = $("<li></li>").text(problemValue);
                  $ul.append($li);
                });
            
                // Insert the UL before the description <p>
                $descParagraph.before($ul);
              }
            }else if(issueType === "fit_problem"){
              var fitProblem = cancelJson.fit_problem;
              $issueTitle.text(fpT('fitProblem', 'Fit Problem')); 
              
              if(fitProblem.image){
              $resultImageElem.attr("src",fitProblem.image);
              }else{
                $(".order-actions-result .summary-image-main").remove();
              }
              var $descParagraph = $summaryInput.find("p");
              $descParagraph.text(fitProblem.issue_description || "");
              // $(".order-actions-result .summary-image-main .summary-image-wrap img").attr('src', requestData.fit_problem.image);  
            }else{
              var otherIssue = cancelJson.other_issue;
              $issueTitle.text(fpT('otherIssue', 'Other Issue')); 

              $(".order-actions-result .summary-image-main").remove();
              var $descParagraph = $summaryInput.find("p");
              $descParagraph.text(otherIssue.issue_description || "");
              
            }

          }
        });
      }
    })
    .catch(error => {
      console.error('Error calling API:', error);
    });
  }
  
  const orderContent = document.querySelector(".account-content.account-order");
  // console.log("orderContentActive",orderContent);
  if(document.body.classList.contains('template-account')){
    const lineItems = orderContent.querySelectorAll(".order-content-data tr");
    console.log("lineItems",lineItems);
    if(lineItems.length){
      lineItems.forEach((lineItem) => {
        const order_id = lineItem.getAttribute("data-order-id");
        const lineitem_id = lineItem.getAttribute("data-lineitem-id");

        // console.log("lineitem_id",lineitem_id);

        const formData = new FormData();
        formData.append('shopify_order_id', order_id);
        
        fetch('https://app.footprint-pioneers.com/shopify/order/info', {
          method: 'POST',
          body: formData, // Don't set Content-Type manually!
        })
        .then(response => response.json())
        .then(data => {
          // console.log('Response from API:', data);
         
          // console.log("Line Ids",data?.data?.line_ids);
          const matchingLineItem = data?.data?.line_ids?.find(item => item.shopify_line_id == lineitem_id);
          if (matchingLineItem) {
            console.log("matchingLineItem",matchingLineItem);
            const {
              state,
              refund_approve_message
            } = matchingLineItem;
            // console.log("state",state);
            // console.log("statusElem",lineItem.querySelector("td[data-label='status']"));
            if(state){
              if(state == 'Return Requested'){
                lineItem.querySelector("td[data-label='status']").innerHTML = "<span class='state'>" +state + "</span>";
              }else{
                lineItem.querySelector("td[data-label='status']").textContent = state;
              }
            }else{
               lineItem.querySelector("td[data-label='status']").textContent = fpT('unfulfilled', 'Unfulfilled');
            }
            // if(state == 'Return Requested'){
            //   lineItem.querySelector("td[data-label='status']").innerHTML = "<span class='state'>" +state + "</span><br><span class='see_return_details'>See Return Details</span>";
            // }else{
            //   lineItem.querySelector("td[data-label='status']").textContent = state;
            // }
          }
        })
        .catch(error => {
          console.error('Error calling API:', error);
        });
      });
    }
  }
});

// Make "Discount codes" text bold in cart tax messages
document.addEventListener('DOMContentLoaded', function() {
  function makeBoldDiscountCodes() {
    const taxNotes = document.querySelectorAll('.cart__footer .tax-note');
    taxNotes.forEach(function(note) {
      if (
        (note.innerHTML.includes('Discounts') && !note.innerHTML.includes('<strong>Discounts</strong>') && !note.innerHTML.includes('<b>Discounts</b>'))
        || (note.innerHTML.includes('Discount codes') && !note.innerHTML.includes('<strong>Discount codes</strong>') && !note.innerHTML.includes('<b>Discount codes</b>'))
        || (note.innerHTML.includes('Rabatte') && !note.innerHTML.includes('<strong>Rabatte</strong>') && !note.innerHTML.includes('<b>Rabatte</b>'))
      ) {
        note.innerHTML = note.innerHTML.replace(/Discount codes/g, '<strong>Discount codes</strong>');
        note.innerHTML = note.innerHTML.replace(/Discounts/g, '<strong>Discounts</strong>');
        note.innerHTML = note.innerHTML.replace(/Rabatte/g, '<strong>Rabatte</strong>');
      }
    });
  }
  
  // Run on page load
  makeBoldDiscountCodes();
  
  // Also run when cart is updated (in case content changes dynamically)
  const cartObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        makeBoldDiscountCodes();
      }
    });
  });
  
  // Start observing the cart footer
  const cartFooter = document.querySelector('.cart__footer');
  if (cartFooter) {
    cartObserver.observe(cartFooter, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
});








// Added by MS
function renderMeasurement(row, product, dateStr) {
  const measureId    = product.form_standard_measure_id;
  const standardSize = product.form_standard_size;
  const scans        = window.customerMetafields?.shoeSizes;

  // Don't append again if already rendered
  if (row.find('.my-scans').length) return;

  // Hide tabs nav and content
  row.find('.size_accordion .accordion__content #tabs-nav, .size_accordion .accordion__content #tabs-content')
     .addClass('hidden');

  // Collapse the accordion
  const $acc = row.find('.cart-accordian');
  $acc.addClass("active");
  $acc.find('.accordion-header').removeAttr('open');

  let html = '';

  if (standardSize) {

    html = `
      <div class="my-scans">
        <div class="my-scans-items">
          <div class="my-scans-wrap" data-standard-size="${standardSize}">
            <div class="my-scans-item active">
              <div class="scan-text">
                <h4>Standard Size</h4>
                <span>${standardSize} EU</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

  } else if (measureId) {

    const matchedScan = scans?.find(scan => scan.id == measureId);

    if (matchedScan) {
      const leftSize  = matchedScan.left.EU;
      const rightSize = matchedScan.right.EU;
      const scanName  = matchedScan.customer_scan_name;

      html = `
        <div class="my-scans">
          <h4>Made-to-measure</h4>
          <div class="my-scans-items">
            <div class="my-scans-wrap"
                 data-measure-id="${measureId}"
                 data-left-size="${leftSize}"
                 data-right-size="${rightSize}">
              <div class="my-scans-item active">
                <div class="scan-image">
                  <img src="https://cdn.shopify.com/s/files/1/0922/3340/0666/files/image_1.png?v=1738066539"
                       data-is-obj="true" alt="">
                </div>
                <div class="scan-text">
                  <h4>${scanName}</h4>
                  <p>Measurements taken on</p>
                  <span>${dateStr || ''}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
    }
  }

  if (html) {
    row.find('.size_accordion .accordion__content').append(html);
  }
}

function updateMeasureButton($tabContent) {
  const $btn = $tabContent.find(".form_measure_btn button");
  const hasActive = $tabContent.find(".my-scans-wrap:has(.my-scans-item.active)").length > 0;
  $btn.prop("disabled", !hasActive);
}

function updateSizeButton($tabContent) {
  const $btn = $tabContent.find(".form_size_btn button");
  const val = $tabContent.find('[name="properties[form_standard_size]"]').val();
  $btn.prop("disabled", !(val && val.trim() !== ""));
}

  $(document).ready(function () {
    $(".form_measure_btn button, .form_size_btn button").prop("disabled", true);

    $(".tab-content").each(function () {
      updateMeasureButton($(this));
      updateSizeButton($(this));
    });

    // NEW: Watch for hidden input value changes
    $('[name="properties[form_standard_size]"]').each(function () {
      const input = this;
      const $tabContent = $(this).closest(".tab-content");

      const observer = new MutationObserver(function () {
        updateSizeButton($tabContent);
      });

      observer.observe(input, {
        attributes: true,
        attributeFilter: ["value"]
      });
    });



    // Auto-hide accordions based on saved localStorage data
    $(".cart-accordian").each(function () {
      const $acc = $(this);

      const lineItemId = $acc.closest(".cart-item").data("item-id");
      if (!lineItemId) return;

      const savedKey = "lineitem_saved_" + lineItemId;
      const savedData = localStorage.getItem(savedKey);

      if (savedData) {
        $acc.addClass("active");
        $acc.find(".accordion-header").removeAttr("open");

        $acc.find(".accordion__content").find("#tabs-nav").addClass("hidden");
        $acc.find(".accordion__content").find("#tabs-content").addClass("hidden");
      }
    });



  });

$(document).on("click", ".my-scans-item", function () {
  const $wrap = $(this).closest(".my-scans-wrap");
  $wrap.find(".my-scans-item").removeClass("active");
  $(this).addClass("active");

  const $tabContent = $(this).closest(".tab-content");
  updateMeasureButton($tabContent);
});

// (This will NOT fire when JS updates val(), but we keep it for manual typing cases)
$(document).on("change keyup", '[name="properties[form_standard_size]"]', function () {
  const $tabContent = $(this).closest(".tab-content");
  updateSizeButton($tabContent);
});

$(document).on("click", ".submit-btn-wrap button", function (e) {
  e.preventDefault();
  let $this = $(this);
  if ($(this).prop("disabled")) return;

  const $row = $(this).closest("tr.cart-item, tr.cst-cart-item");
  const itemId = $row.data("item-id") || null;

  const $orderMain = $(".order-main");
  const orderId = $orderMain.data("order-id") || null;
  const lineItemId = $orderMain.data("line-item-id") || null;
  const customerId = $orderMain.data("customerid") || null;

  const $tab = $(this).closest(".tab-content");

  let measureId = null;
  let standardSize = null;

  if ($(this).closest(".form_measure_btn").length) {
    const $activeScan = $tab.find(".my-scans-wrap:has(.my-scans-item.active)");
    if ($activeScan.length) measureId = $activeScan.data("measure-id");
  }

  if ($(this).closest(".form_size_btn").length) {
    const $std = $tab.find('[name="properties[form_standard_size]"]');
    if ($std.length) standardSize = $std.val();
  }

  const payload = {
    id: customerId,
    order_id: orderId,
    line_item_id: lineItemId,
    item_id: itemId,
    form_standard_measure_id: measureId,
    form_standard_size: standardSize
  };

  const selectionLabel = measureId
    ? "the scan measurement"
    : `the standard EU size${standardSize ? ` ${standardSize}` : ""}`;
  if (!window.confirm(
    `Please confirm that you want to select ${selectionLabel} for this order. ` +
    "This choice will be locked and cannot be changed later."
  )) {
    return;
  }

  $.ajax({
    url: "https://app.footprint-pioneers.com/backend/update_lineitem_shoesize",
    method: "POST",
    data: JSON.stringify(payload),
    contentType: "application/json; charset=UTF-8",
    dataType: "json",
    success: function (response) {
      console.log("API RESPONSE:", response);
      // $this.parents(".cart-accordian").addClass("active");


      const $acc = $this.closest(".cart-accordian");
      // Remove open attribute
      $acc.find(".accordion-header").removeAttr("open");

      // Add hidden class to content
      // $acc.find(".accordion__content").addClass("hidden");
      $acc.find(".accordion__content").find("#tabs-nav").addClass("hidden");
      $acc.find(".accordion__content").find("#tabs-content").addClass("hidden");



      const dataKey = "lineitem_saved_" + itemId;
      localStorage.setItem(dataKey, JSON.stringify(payload));

      // Read back from localStorage
      // const saved = localStorage.getItem(dataKey);

      // if (saved) {
      //   const savedPayload = JSON.parse(saved);
      //   const row = $(`tr[data-item-id="${itemId}"]`);

      //   if (row.length) {
      //     renderMeasurement(row, savedPayload, null);
      //   }
      // }

      // Read back from localStorage
        const saved = JSON.parse(localStorage.getItem(dataKey));
        const scans  = window.customerMetafields?.shoeSizes;
        const row    = $(`tr[data-item-id="${itemId}"]`);

        if (saved && row.length) {

          const measureId    = saved.form_standard_measure_id;
          const standardSize = saved.form_standard_size;

          // Collapse the accordion
          const $acc = $this.closest(".cart-accordian");
          $acc.find(".accordion-header").removeAttr("open");
          $acc.find(".accordion__content").find("#tabs-nav").addClass("hidden");
          $acc.find(".accordion__content").find("#tabs-content").addClass("hidden");

          let html = '';

          if (standardSize) {

            html = `
              <div class="my-scans">
                <div class="my-scans-items">
                  <div class="my-scans-wrap" data-standard-size="${standardSize}">
                    <div class="my-scans-item active">
                      <div class="scan-text">
                        <h4>Standard Size</h4>
                        <span>${standardSize} EU</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            `;

          } else if (measureId) {

            const matchedScan = scans?.find(scan => scan.id == measureId);

            if (matchedScan) {
              const leftSize  = matchedScan.left.EU;
              const rightSize = matchedScan.right.EU;
              const scanName  = matchedScan.customer_scan_name;
              const scanDate  = matchedScan.date;

              html = `
                <div class="my-scans">
                  <h4>Made-to-measure</h4>
                  <div class="my-scans-items">
                    <div class="my-scans-wrap"
                        data-measure-id="${measureId}"
                        data-left-size="${leftSize}"
                        data-right-size="${rightSize}">
                      <div class="my-scans-item active">
                        <div class="scan-image">
                          <img src="https://cdn.shopify.com/s/files/1/0922/3340/0666/files/image_1.png?v=1738066539"
                              data-is-obj="true" alt="">
                        </div>
                        <div class="scan-text">
                          <h4>${scanName}</h4>
                          <p>Measurements taken on</p>
                          <span>${scanDate}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              `;
            }
          }

          if (html) {
            row.find('.size_accordion .accordion__content').append(html);
          }
        }

    },
    error: function (xhr) {
      console.error("API ERROR:", xhr.responseText || xhr);
    }
  });
});


// Get measuremtn based on API response 

document.addEventListener("DOMContentLoaded", async function () {
  const customerId = window.customerMetafields?.customerId;

  if (!customerId) {
    console.warn("No customer ID found.");
    return;
  }

  try {
    const res = await fetch("https://app.footprint-pioneers.com/backend/get_pending_size_orders", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ id: customerId })
    });

    const response = await res.json();

    if (!response.result.error) {
      const orders = response.result.orders;
      const scans = window.customerMetafields?.shoeSizes;

      console.log("scans====>",scans);

      orders.forEach(order => {

        if (order.size_already_selected === true) {

          order.products.forEach(product => {
            const lineItemId          = product.line_item_id;
            const measureId           = product.form_standard_measure_id;
            const standardSize        = product.form_standard_size;
            const row                 = $(`tr[data-item-id="${lineItemId}"]`);

            if (row.length) {

              // Hide tabs nav and content
              row.find('.size_accordion .accordion__content #tabs-nav, .size_accordion .accordion__content #tabs-content')
                 .addClass('hidden');

              // Collapse the accordion
              const $acc = row.find('.cart-accordian');
              $acc.addClass("active");
              $acc.find('.accordion-header').removeAttr('open');

              let html = '';

               if (standardSize) {

                  html = `
                    <div class="my-scans">
                      <div class="my-scans-items">
                        <div class="my-scans-wrap"
                            data-standard-size="${standardSize}">
                            <div class="my-scans-item active">
                              <div class="scan-text">
                                <h4>Standard Size</h4>
                                <span>${standardSize} EU</span>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  `;

              } else if (measureId) {
                const matchedScan = scans?.find(scan => scan.id == measureId);

                if (matchedScan) {
                  const leftSize  = matchedScan.left.EU;
                  const rightSize = matchedScan.right.EU;
                  const scanName  = matchedScan.customer_scan_name;
                  const scanDate  = matchedScan.date;

                  html = `
                    <div class="my-scans">
                    <h4>Made-to-measure </h4>
                      <div class="my-scans-items">
                        <div class="my-scans-wrap"
                             data-measure-id="${measureId}"
                             data-left-size="${leftSize}"
                             data-right-size="${rightSize}">
                          <div class="my-scans-item active">
                            <div class="scan-image">
                              <img src="https://cdn.shopify.com/s/files/1/0922/3340/0666/files/image_1.png?v=1738066539"
                                   data-is-obj="true" alt="">
                            </div>
                            <div class="scan-text">
                              <h4>${scanName}</h4>
                              <p>Measurements taken on</p>
                              <span>${scanDate}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  `;
                }
              }

              if (html) {
                row.find('.size_accordion .accordion__content').append(html);
              }

            }
          });
        }

      });
    }

  } catch (err) {
    console.error("Failed to fetch pending size orders:", err);
  }
});




// $(document).ready(function() {
//   $('#size-selected-checked').on('change', function() {
//     if ($(this).is(':checked')) {
//       $('.size-selector-checkbox').addClass('active');
//     } else {
//       $('.size-selector-checkbox').removeClass('active');
//     }
//   });

//   // run on page load if already checked
//   if ($('#size-selected-checked').is(':checked')) {
//     $('.size-selector-checkbox').addClass('active');
//   }
// });

$(document).ready(function() {
  function updateValue() {
    const isChecked = $('#size-selected-checked').is(':checked');

    $('.size-selector-checkbox').toggleClass('active', isChecked);

    $('#size-selection-value').val(isChecked ? 'Yes' : 'No');
  }

  $('#size-selected-checked').on('change', function () {
    updateValue();
    window.fpClarity?.track('cart_size_deferred', {
      cart_size_deferred: $(this).is(':checked') ? 'yes' : 'no',
    });
  });

  // run on load
  updateValue();
});


// Clear cart before add new
let isProcessing = false;

document.addEventListener('click', async function (e) {
  const btn = e.target.closest('.tda-customizer-footer-atc-btn');

  if (!btn) return;

  // Ignore programmatic clicks
  if (!e.isTrusted) return;

  if (isProcessing) return;


  e.preventDefault();
  e.stopImmediatePropagation();

  isProcessing = true;

  try {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    if (cart.items.length > 0) {

      // ✅ Show confirm ONLY if cart has items
      const result = confirm(window.fpStrings?.replaceCartConfirm || 'Your cart already has items. Currently, you can only order one pair of shoes at a time. Do you want to replace the current item?');

      if (!result) {
        window.fpClarity?.track('configurator_add_to_cart_cancelled');
        isProcessing = false; // important reset
        return; // ❌ Stop if user cancels
      }

      window.fpClarity?.track('configurator_add_to_cart', {
        configurator_cart_replaced: 'true',
      });
      await fetch('/cart/clear.js', { method: 'POST' });
    } else {
      window.fpClarity?.track('configurator_add_to_cart', {
        configurator_cart_replaced: 'false',
      });
    }

    setTimeout(() => {
      isProcessing = false;

      // ✅ Dispatch a clean one-time event
      const newEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });

      // Temporarily disable listener
      document.removeEventListener('click', arguments.callee, true);
      btn.dispatchEvent(newEvent);

      // Re-attach listener
      setTimeout(() => {
        document.addEventListener('click', arguments.callee, true);
      }, 0);

    }, 300);

  } catch (err) {
    console.error(err);
    isProcessing = false;
  }
}, true);

// Mobile configurator: measure fixed footer so the options panel clears it
(function initConfiguratorMobileLayout() {
  if (!document.body.classList.contains('template-product') || document.body.classList.contains('gift-card-product')) {
    return;
  }

  var mobileQuery = window.matchMedia('(max-width: 989px)');

  function syncFooterHeight() {
    if (!mobileQuery.matches) {
      document.body.style.removeProperty('--fp-configurator-footer-height');
      return;
    }

    var footer = document.querySelector('.tda-customizer-footer');
    if (!footer) return;

    document.body.style.setProperty('--fp-configurator-footer-height', Math.ceil(footer.getBoundingClientRect().height) + 'px');
  }

  var timer;
  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(syncFooterHeight, 50);
  }

  window.addEventListener('resize', scheduleSync);
  window.addEventListener('orientationchange', scheduleSync);

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleSync);
  }

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', scheduleSync);
  }

  var bootAttempts = 0;
  var bootTimer = setInterval(function() {
    bootAttempts += 1;
    if (document.querySelector('.tda-customizer-footer')) {
      syncFooterHeight();
      clearInterval(bootTimer);
    } else if (bootAttempts >= 30) {
      clearInterval(bootTimer);
    }
  }, 300);
})();

(function localizeConfiguratorChrome() {
  if (!document.body.classList.contains('template-product') || document.body.classList.contains('gift-card-product')) {
    return;
  }

  var applying = false;
  var scheduled = false;

  function setTextIfChanged(el, value) {
    if (!el || !value) return;
    if (el.textContent.trim() === value) return;
    el.textContent = value;
  }

  function apply() {
    var strings = window.fpStrings || {};
    var root = document.querySelector('.tda-customizer-wrapper') || document.body || document;

    applying = true;
    try {
      root.querySelectorAll('.tda-customizer-footer-atc-btn').forEach(function (el) {
        setTextIfChanged(el, strings.addToCart);
      });
      root.querySelectorAll('.tda-customizer-footer-buy-btn').forEach(function (el) {
        setTextIfChanged(el, strings.buyNow);
      });

      root.querySelectorAll('button, a, span, label, h1, h2, h3, p, div, li').forEach(function (el) {
        if (el.children.length !== 0 && !el.matches('button, a, label, h1, h2, h3, p')) return;
        var text = (el.textContent || '').trim();
        var inConfigurator = el.closest('.tda-customizer-footer') != null || el.closest('.tda-customizer') != null;

        if (strings.addToCart && /^(add to cart|in den warenkorb legen)$/i.test(text)) {
          setTextIfChanged(el, strings.addToCart);
        } else if (strings.buyNow && /^(buy now|jetzt kaufen)$/i.test(text)) {
          setTextIfChanged(el, strings.buyNow);
        } else if (
          strings.noCustomization &&
          /^(no customization has been created for this 3d model\.?|für dieses 3d-modell wurde noch keine anpassung erstellt\.?)$/i.test(
            text
          )
        ) {
          setTextIfChanged(el, strings.noCustomization);
        } else if (
          strings.createCustomization &&
          /^(you can create a customization now by clicking|sie können jetzt eine anpassung erstellen, indem sie klicken)$/i.test(
            text
          )
        ) {
          setTextIfChanged(el, strings.createCustomization);
        } else if (
          strings.loadingConfigurator &&
          /^(loading 3d configurator|3d-konfigurator wird geladen)$/i.test(text)
        ) {
          setTextIfChanged(el, strings.loadingConfigurator);
        } else if (
          strings.customizationMerchantNote &&
          (/\(don't worry! your customers will not see this error message/i.test(text) ||
            /\(keine sorge! ihre kunden sehen diese fehlermeldung/i.test(text))
        ) {
          setTextIfChanged(el, strings.customizationMerchantNote);
        } else if (inConfigurator && strings.quantity && /^(quantity|anzahl)$/i.test(text)) {
          setTextIfChanged(el, strings.quantity);
        } else if (inConfigurator && strings.customize && /^(customize|anpassen)$/i.test(text)) {
          setTextIfChanged(el, strings.customize);
        } else if (inConfigurator && strings.sale && /^(sale)$/i.test(text)) {
          setTextIfChanged(el, strings.sale);
        } else if (inConfigurator && strings.configurator3d && /^(3d configurator|3d-konfigurator)$/i.test(text)) {
          setTextIfChanged(el, strings.configurator3d);
        }
      });
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    if (applying || scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      apply();
    });
  }

  apply();

  var observer = new MutationObserver(function () {
    if (applying) return;
    scheduleApply();
  });

  function observeRoot() {
    if (!document.body) return false;
    observer.observe(document.body, { childList: true, subtree: true });
    return true;
  }

  if (!observeRoot()) {
    var bootAttempts = 0;
    var bootTimer = setInterval(function () {
      bootAttempts += 1;
      if (observeRoot() || bootAttempts >= 30) {
        clearInterval(bootTimer);
      }
    }, 300);
  }
})();